import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Modal,
  DatePicker,
  Col,
  Row,
  Divider,
  Select,
  Typography,
  Space,
  Card,
  Drawer,
} from "antd";
import "./add-driver.scss";
import Fileupload from "../../common/fileupload/fileupload";
import Notification from "../../service/notification";
import * as driverService from "../../service/fleet-management/driverService";
import * as masterDataService from "../../service/masterDataService";
import { useTranslation } from "react-i18next";
import { useStore } from "../../store/store";
import Placepicker from "../../common/placepicker/placepicker";
import ExistsImg from "../../assets/images/exists img.svg";
import EditImg from "../../assets/images/pencil-edit.svg";
import DriverGruardImg from "../../assets/images/driver-guard-img.svg";
import UaeFlag from "../../assets/images/uae-flag.svg";
import TurkeyFlag from "../../assets/images/Turkey-flag.svg";
import DocFileImg from "../../assets/images/Doc-Content.svg";
import {
  CheckCircleOutlined,
  PlusOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import moment from "moment";
import dayjs from "dayjs";
import { DocTypes, EntityTypes } from "../../constants/commonConstants";
import { validateNotEmpty } from "../../util/inputValidateUtils";
import {
  getMinAndMaxLengthForMobileNumber,
  getMobileCountryCodeList,
  validateMobileNumber,
} from "../../util/countryWiseMobileNumberUtils";
import { fetchCountryCodeFromGeo } from "../../util/getGeoCountryCode";
import AutofillDocUpload from "../login/sign-up/components/autofill-doc-upload";
import {
  ocrCustomFileUploadService,
  uploadDocumentV2,
} from "../../service/documentService";
import { initialUploadState } from "./fleet-management";
import DocumentListView from "../login/sign-up/components/document-list-view";
import OCRFileUpload from "../../common/ocr-file-upload/ocr-file-upload";
import MissingDocModal from "../login/sign-up/components/missing-doc-modal";
import * as documentUtility from "../../util/documentThumbUtility";
import DiscardWarningModal from "../../common/discard-warnig-modal/discard-warning-modal";
import OCRFilePreviewUploader from "../../common/ocr-file-preview-uploader/ocr-file-preview-uploader";
import { toTitleCase } from "../../util/toTitleCase";
import { removeUniquenessCheckForCountry } from "../../util/constantUtility";

const { Text } = Typography;
const format = "DD/MM/YYYY";

const AddDriver = ({
  isOpen,
  onClose,
  formType,
  editformValues,
  refresh,
  setDrivers,
  supplierId,
  // OCR props
  setIsUploadingPopupVisible,
  setUploadState,
  setSamplePreviewOpen,
  setSampleType,
  setCountryCodeName,
}) => {
  const { t } = useTranslation();
  const [minMaxMobileNoLength, setMinMaxMobileNoLength] = useState(
    getMinAndMaxLengthForMobileNumber()
  );
  const [addDriverForm] = Form.useForm();
  console.log("adaddDriverFormd", addDriverForm.getFieldsValue());

  const [nextBtn, setNextBtn] = useState(false);
  const [isOcrFileUpload, setIsOcrFileUpload] = useState(false);

  console.log("ADD DRIVER nextBtn", nextBtn);
  const [nextBtnTwo, setNextBtnTwo] = useState(
    formType === "editForm" ? true : false
  );
  console.log("ADD DRIVER nextBtnTwo", nextBtnTwo);
  const [btnLoader, setBtnLoader] = useState(false);
  const [verifyMobile, setVerifyMobile] = useState(false);
  const [mobileCountryCodeLoader, setMobileCountryCodeLoader] = useState(false);
  const [mobileCountryCodeList, setMobileCountryCodeList] = useState([]);
  const [addressDetail, setAddressDetail] = useState({
    address: "",
    latitude: 0,
    longitude: 0,
  });
  const [cityOptions, setCityOptions] = useState([]);
  const [cityOptionsWaiter, setCityOptionsWaiter] = useState(false);
  const [serviceTypesList, setServiceTypesList] = useState([
    {
      serviceTypeCode: "CB",
      serviceTypeDesc: "Cross Border",
      serviceTypeName: "CrossBorder",
    },
    {
      serviceTypeCode: "DOM",
      serviceTypeDesc: "Domestic",
      serviceTypeName: "Domestic",
    },
  ]);
  const [countriesListWaiter, setCountriesListWaiter] = useState(false);
  const [issuingCountriesListWaiter, setIssuingCountriesListWaiter] =
    useState(false);
  const [countryOptions, setCountryOptions] = useState();
  const { user, saveUser } = useStore();
  console.log("ADD DRIVER user", user);
  const [formValues, setFormValues] = useState({});

  console.log("formValues ADD DRIVER form", formValues);

  const [driverExist, setDriverExist] = useState(false);
  const [addFleet, setAddFleet] = useState(false);
  console.log("addFleet addFleet", addFleet);
  const [driverData, setDriverData] = useState(null);
  const [driverId, setDriverId] = useState(null);
  const [driverDocs, setDriverDocs] = useState([]);
  const [visa, setVisa] = useState([
    {
      associateId: "",
      documentNumber: "",
      expiryDate: "",
      issuingCountry: "",
      document: [
        {
          // isInsertUpdate: false,
          isPathSet: true,
          documentPath: "",
          documentPathThumb: "",
          fileName: "",
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: false,
        },
      ],
      frontDoc: {
        documentPath: "",
        documentPathThumb: "",
        fileName: "",
        // isInsertUpdate: false,
        isPathSet: true,
        // *****  OCR NEW KEY ADDED
        isInsertUpdate: false,
        isOCRDoc: false,
      },
    },
  ]);

  const defaultDoc = {
    docType: "INQDOC",
    fileName: "asdfgh",
    // isInsertUpdate: false,
    fileThumbName: "sadfgh",
    index: 0,
    // *****  OCR NEW KEY ADDED
    isInsertUpdate: false,
    isOCRDoc: false,
  };
  const [frontDocs, setFrontDocs] = useState([{ ...defaultDoc }]);
  const [isCountryCodeInitialized, setIsCountryCodeInitialized] =
    useState(false);

  // ******************* OCR File Uploads STATES *****************
  // const initialUploadState = {
  //   progress: 0,
  //   status: "Hold Tight - File is Being Prepared Securely.",
  //   description: "Please don’t close or refresh the screen",
  //   started: false,
  // };
  const [ownerType, setOwnerType] = useState("IndividualOwner");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [ocrConfirmedFiles, setOcrConfirmedFiles] = useState([]);
  const [ocrParsedData, setOcrParsedData] = useState(null);
  const [ocrLogId, setOcrLogId] = useState("");

  console.log("ocrLogId", ocrLogId);

  // const [uploadState, setUploadState] = useState(initialUploadState);

  // Drawer State
  const [openDrawer, setOpenDrawer] = useState(false);
  const [missingDocModal, setMissingDocModal] = useState(false);

  // Discard  moadl State
  const [isDiscardModalVisible, setIsDiscardModalVisible] = useState(false);

  //
  // const [isUploadingPopupVisible, setIsUploadingPopupVisible] = useState(false);

  useEffect(() => {
    if (ocrParsedData?.documents?.length) {
      const { documents } = ocrParsedData;

      const email =
        documents.find((doc) => doc.status === true && doc.emailID)?.emailID ||
        "";
      console.log("ADD DRIVER ocrParsedData.emailID ", email);
      const name =
        documents.find((doc) => doc.status === true && doc.nameInEnglish)
          ?.nameInEnglish || "";

      const drivingLicenseDoc = documents.find(
        (doc) => doc.docType === "DRIVING_LICENSE" && doc.status === true
      );
      console.log("ADD DRIVER tradeLicenseDoc", drivingLicenseDoc);

      const passportDoc = documents.find(
        (doc) => doc.docType === "PASSPORT" && doc.status === true
      );

      const nationalIdDoc = documents.find(
        (doc) => doc.docType === "NATIONAL_ID" && doc.status === true
      );

      const visaDocs = documents.filter(
        (doc) => doc.docType === "VISA" && doc.status === true
      );

      setFormValues((prev) => ({
        ...prev,
        driverName: toTitleCase(name) || undefined,
      }));
      addDriverForm.setFieldsValue({
        driverName: toTitleCase(name) || undefined,
      });

      // DRIVING LICENSE
      if (drivingLicenseDoc?.docNumber || drivingLicenseDoc?.docExpiryDate) {
        const { docNumber, docExpiryDate } = drivingLicenseDoc;
        // const parsedLicenceExpiry = docExpiryDate
        //   ? moment(drivingLicenseDoc.docExpiryDate, "DD-MM-YYYY")
        //   : null;

        const parsedLicenceExpiry = docExpiryDate
          ? dayjs(drivingLicenseDoc.docExpiryDate, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            )
          : null;

        console.log("ADD DRIVER parsedLicenceExpiry", parsedLicenceExpiry);

        const frontDoc = {
          EntityId: EntityTypes.DRIVER,
          FileName:
            `ActualDriver/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.frontUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.frontUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(drivingLicenseDoc.frontUrl) ||
            null,
          FileURL: drivingLicenseDoc.frontUrl || null,
          Status: false,
          FileUrl: drivingLicenseDoc.frontUrl || null,
          // isInsertUpdate: true,
          isPathSet: true,
          FileThumbUrl:
            documentUtility.getThumbnailImagePath(drivingLicenseDoc.frontUrl) ||
            null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const backDoc = {
          EntityId: EntityTypes.DRIVER,
          FileName:
            `ActualDriver/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.backUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.frontUrl
            )}` || null,
          FileThumbURL: drivingLicenseDoc.backUrl || null,
          FileURL: drivingLicenseDoc.backUrl || null,
          Status: false,
          FileUrl: drivingLicenseDoc.backUrl || null,
          // isInsertUpdate: true,
          isPathSet: true,
          FileThumbUrl:
            documentUtility.getThumbnailImagePath(drivingLicenseDoc.frontUrl) ||
            null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          drivingLicenseNumber: docNumber || undefined,
          licenseExpiry: parsedLicenceExpiry,
          licenceFront: frontDoc,
          licenceBack: backDoc,
        }));
        addDriverForm.setFieldsValue({
          drivingLicenseNumber: docNumber || undefined,
          licenseExpiry: parsedLicenceExpiry,
          licenceFront: frontDoc,
          licenceBack: backDoc,
        });
      }
      // PASSPORT DOC
      if (passportDoc?.docNumber || passportDoc?.docExpiryDate) {
        const { docNumber, docExpiryDate } = passportDoc;
        // const parsedPassportExpiry = docExpiryDate
        //   ? moment(docExpiryDate, "DD-MM-YYYY")
        //   : null;

        const parsedPassportExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;
        console.log("ADD DRIVER parsedPassportExpiry", parsedPassportExpiry);

        const passportFront = {
          DocType: "PASSBD",
          EntityId: EntityTypes.DRIVER,
          FileName:
            `ActualDriver/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.frontUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.frontUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(passportDoc.frontUrl) || null,
          FileURL: passportDoc.frontUrl || null,
          Status: false,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const passportBack = {
          DocType: "PASSBD",
          EntityId: EntityTypes.SUPPLIER,
          FileName:
            `ActualDriver/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.backUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.backUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(passportDoc.backUrl) || null,
          FileURL: passportDoc.backUrl || null,
          Status: false,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          passportNumber: docNumber || undefined,
          passportExpiry: parsedPassportExpiry,
          passportFront: passportFront,
          passportBack: passportBack,
        }));
        addDriverForm.setFieldsValue({
          passportNumber: docNumber || undefined,
          passportExpiry: parsedPassportExpiry,
          passportFront: passportFront,
          passportBack: passportBack,
        });
      }
      // NATIONAL ID
      if (nationalIdDoc?.docNumber || nationalIdDoc?.docExpiryDate) {
        const { docNumber, docExpiryDate } = nationalIdDoc;
        // const parsedNationalIdExpiry = docExpiryDate
        //   ? moment(docExpiryDate, "DD/MM/YYYY")
        //   : null;

        const parsedNationalIdExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const nationalIdFront = {
          EntityId: EntityTypes.DRIVER,
          FileName:
            `ActualDriver/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.frontUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.frontUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(nationalIdDoc.frontUrl) ||
            null,
          FileURL: nationalIdDoc.frontUrl || null,
          Status: false,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const nationalIdBack = {
          EntityId: EntityTypes.DRIVER,
          FileName:
            `ActualDriver/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.backUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.backUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(nationalIdDoc.backUrl) ||
            null,
          FileURL: nationalIdDoc.backUrl || null,
          Status: false,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          nationalId: docNumber || undefined,
          nationalIdExpiry: parsedNationalIdExpiry,
          nationalIdFront,
          nationalIdBack,
        }));

        addDriverForm.setFieldsValue({
          nationalId: docNumber || undefined,
          nationalIdExpiry: parsedNationalIdExpiry,
          nationalIdFront,
          nationalIdBack,
        });
      }

      // VISA
      if (visaDocs.length > 0) {
        const formattedVisas = visaDocs.map((doc, index) => ({
          index,
          documentNumber: doc.docNumber || "",
          issuingCountry: doc.issueCountry || "",

          expiryDate: doc.docExpiryDate
            ? dayjs(doc.docExpiryDate, "DD-MM-YYYY").isValid()
              ? dayjs(doc.docExpiryDate, "DD-MM-YYYY").format("YYYY-MM-DD")
              : doc.docExpiryDate
            : "",

          frontDoc: {
            // isInsertUpdate: true,
            isPathSet: true,
            documentPath: doc.frontUrl || "",
            documentPathThumb:
              documentUtility.getThumbnailImagePath(doc.frontUrl) || "",
            fileName:
              `ActualDriver/${ocrLogId}_VISA_${index}_${documentUtility.getFileExtension(
                doc.frontUrl
              )}` || "",
            // *****  OCR NEW KEY ADDED
            isInsertUpdate: false,
            isOCRDoc: true,
          },
        }));

        setVisa(formattedVisas);
        addDriverForm.setFieldsValue({
          visa: formattedVisas,
        });
      }

      // ******** SERVICE TYPE SELECTION ************
      let preSelectedServiceType = [];

      if (passportDoc || visaDocs.length > 0) {
        const crossBorder = serviceTypesList.find(
          (type) => type.serviceTypeName === "CrossBorder"
        );
        if (crossBorder) {
          preSelectedServiceType.push(crossBorder.serviceTypeName);
        }
      } else {
        const domestic = serviceTypesList.find(
          (type) => type.serviceTypeName === "Domestic"
        );
        if (domestic) {
          preSelectedServiceType.push(domestic.serviceTypeName);
        }
      }

      if (preSelectedServiceType.length > 0) {
        setFormValues((prev) => ({
          ...prev,
          serviceType: preSelectedServiceType,
        }));
        addDriverForm.setFieldsValue({
          serviceType: preSelectedServiceType,
        });
      }
    }
  }, [ocrParsedData]);

  // **************************

  // useEffect(() => {
  //   if (user?.userRole) {
  //     setOwnerType(user.userRole);
  //   }
  // }, [user]);

  useEffect(() => {
    getCountries();
    // getServiceTypes();
  }, []);

  useEffect(() => {
    const initializeCountryCode = async () => {
      // Fetch browser location country code
      const geoCountryCode = await fetchCountryCodeFromGeo();
      const filteredCountry = mobileCountryCodeList?.find(
        (item) => item.country_code === geoCountryCode
      );

      if (filteredCountry && !addDriverForm?.getFieldValue("countryCode")) {
        addDriverForm.setFieldValue("countryCode", filteredCountry?.phone_code);
        setIsCountryCodeInitialized(true);
      }
    };

    initializeCountryCode();
  }, [mobileCountryCodeList]);

  useEffect(() => {
    if (editformValues) {
      const formattedValues = {
        countryCode: editformValues.countryCode,
        mobileNumber: editformValues.mobileNumber,
        driverName: editformValues.name,
        serviceType: editformValues.shipmentType,
        country: editformValues.country,
        city: editformValues.city,
        address: editformValues.address,
        isMobileNumberVerified:editformValues?.isMobileNumberVerified ?      editformValues?.isMobileNumberVerified : false,
        addressDetail: {
          address: editformValues.addressDetail?.address || "",
          latitude: editformValues.addressDetail?.latitude || "",
          longitude: editformValues.addressDetail?.longitude || "",
        },
        licenceFront: {
          FileName: editformValues.drivingLicense?.frontDoc?.fileName,
          FileURL: editformValues.drivingLicense?.frontDoc?.documentPath,
          FileThumbURL:
            editformValues.drivingLicense?.frontDoc?.documentPathThumb,
          isInsertUpdate: false,
        },
        licenceBack: {
          FileName: editformValues.drivingLicense?.backDoc?.fileName,
          FileURL: editformValues.drivingLicense?.backDoc?.documentPath,
          FileThumbURL:
            editformValues.drivingLicense?.backDoc?.documentPathThumb,
          isInsertUpdate: false,
        },
        drivingLicenseNumber: editformValues?.drivingLicense?.documentNumber,
        licenseExpiry: editformValues?.drivingLicense?.expiryDate
          ? moment(editformValues.drivingLicense?.expiryDate).format(format)
          : null,
        nationalIdFront: {
          FileName: editformValues.nationalID?.frontDoc?.fileName,
          FileURL: editformValues.nationalID?.frontDoc?.documentPath,
          FileThumbURL: editformValues.nationalID?.frontDoc?.documentPathThumb,
          isInsertUpdate: false,
        },
        nationalIdBack: {
          FileName: editformValues.nationalID?.backDoc?.fileName,
          FileURL: editformValues.nationalID?.backDoc?.documentPath,
          FileThumbURL: editformValues.nationalID?.backDoc?.documentPathThumb,
          isInsertUpdate: false,
        },
        nationalId: editformValues.nationalID?.documentNumber,
        nationalIdExpiry: editformValues?.nationalID?.expiryDate
          ? moment(editformValues.nationalID?.expiryDate).format(format)
          : null,
        passportFront: {
          FileName: editformValues.passport?.frontDoc?.fileName,
          FileURL: editformValues.passport?.frontDoc?.documentPath,
          FileThumbURL: editformValues.passport?.frontDoc?.documentPathThumb,
          isInsertUpdate: false,
        },
        passportBack: {
          FileName: editformValues.passport?.backDoc?.fileName,
          FileURL: editformValues.passport?.backDoc?.documentPath,
          FileThumbURL: editformValues.passport?.backDoc?.documentPathThumb,
          isInsertUpdate: false,
        },
        passportNumber: editformValues?.passport?.documentNumber,
        passportExpiry: editformValues?.passport?.expiryDate
          ? moment(editformValues?.passport?.expiryDate).format(format)
          : null,
        visa: editformValues?.visa,
      };
      const formattedVisa =
        editformValues?.visa?.map((val) => ({
          ...val,
          expiryDate: val?.expiryDate
            ? moment(val?.expiryDate).format(format)
            : null,
        })) || [];
      setVisa(formattedVisa);
      addDriverForm.setFieldsValue(formattedValues);
      setFormValues(formattedValues);
    }
  }, [editformValues]);

  useEffect(() => {
    getCountryMobileCodeMaster();
  }, []);

  const disablePastDates = (current) => {
    return current && current <= dayjs().endOf("day");
  };

  const addVisa = () => {
    setVisa([
      ...visa,
      {
        associateId: "",
        documentNumber: "",
        expiryDate: "",
        issuingCountry: "",
        frontDoc: {
          documentPath: "",
          documentPathThumb: "",
          fileName: "",
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: true,
          isOCRDoc: false,
        },
        document: [
          {
            documentPath: "",
            documentPathThumb: "",
            fileName: "",
          },
        ],
      },
    ]);
  };

  const handleVisa = (val, index) => {
    const tempList = [...visa];
    tempList[index] = {
      ...tempList[index],
      // frontDoc: {
      //   ...tempList[index].frontDoc,
      //   fileName: val.FileName || tempList[index].frontDoc.fileName,
      //   documentPath: val.FileURL || tempList[index].frontDoc.documentPath,
      //   documentPathThumb:
      //     val.FileThumbURL || tempList[index].frontDoc.documentPathThumb,
      //     isInsertUpdate:true,
      //     isPathSet:true
      // },
      documentNumber: val.documentNumber || tempList[index]?.documentNumber,
      issuingCountry: val.issuingCountry || tempList[index]?.issuingCountry,
      expiryDate: val?.expiryDate
        ? moment(val?.expiryDate, format).format("YYYY-MM-DD")
        : null || tempList[index]?.expiryDate,
    };
    setVisa(tempList);
    handleFormChange("visa", tempList);
  };

  const handleVisaDocumentChange = (val, index, documentIndex) => {
    let localVisa = [...visa];
    localVisa[index].frontDoc = {
      fileName: val.FileName,
      documentPath: val.FileURL,
      documentPathThumb: val.FileThumbURL,
      // isInsertUpdate: true,
      // *****  OCR NEW KEY ADDED
      isInsertUpdate: true,
      isOCRDoc: false,
    };
    // localVisa[index].document[documentIndex] = {
    //   documentPath: val.FileURL,
    //   documentPathThumb: val.FileThumbURL,
    //   fileName: val.FileName,
    //   isInsertUpdate: true,
    // };
    setVisa(localVisa);
    handleFormChange("visa", localVisa);
  };

  const addVisaDocument = (visaIndex) => {
    let localVisa = [...visa];

    localVisa[visaIndex].document.push({
      documentPath: "",
      documentPathThumb: "",
      fileName: "",
      // isInsertUpdate: true,
      // *****  OCR NEW KEY ADDED
      isInsertUpdate: true,
      isOCRDoc: false,
    });
    setVisa(localVisa);
    handleFormChange("visa", localVisa);
  };

  const getCityList = (value, index) => {
    setCityOptionsWaiter(true);
    masterDataService
      .getCityMasterByCountry(value)
      .then((response) => {
        setCityOptionsWaiter(false);
        if (response.status === 200) {
          setCityOptions(response.data);
        }
      })
      .catch((error) => {
        setCityOptionsWaiter(false);
        setCityOptions([]);
      });
  };

  const handleLocationChange = (selectedAddress) => {
    setAddressDetail((prev) => {
      return {
        ...prev,
        address: selectedAddress.address,
        latitude: selectedAddress.lat,
        longitude: selectedAddress.lng,
      };
    });
  };

  const handleCountryChange = (value, option) => {
    addDriverForm.setFieldsValue({ country: value });
    addDriverForm.setFieldsValue({ city: null });
  };

  const getCountries = () => {
    setCountriesListWaiter(true);
    masterDataService
      .getCountryMaster()
      .then((res) => {
        setCountriesListWaiter(false);
        if (res.status === 200) {
          setCountryOptions(res.data);
          let countries = [];
          user?.dataProtectionDetail?.country?.forEach((ele) => {
            countries.push(ele);
          });
          user?.dataProtectionDetail?.externalShipperMasterIds?.forEach(
            (ele) => {
              if (!countries?.includes(ele.country)) {
                countries.push(ele.country);
              }
            }
          );
          let localCountries = res.data.filter(
            (ele) => countries?.indexOf(ele.name) !== -1
          );
          // setCountries(localCountries);
        }
      })
      .catch((err) => {
        setCountriesListWaiter(false);
      });
  };

  const getCountryMobileCodeMaster = async (countryCode = "") => {
    setMobileCountryCodeLoader(true);
    try {
      const response = await masterDataService.getCountryMobileCodeMaster(
        countryCode,
        true
      );
      if (response.status === 200) {
        setMobileCountryCodeList(getMobileCountryCodeList(response.data, true));
      }
      setMobileCountryCodeLoader(false);
    } catch (error) {
      setMobileCountryCodeLoader(false);
    }
  };

  const handleFormChange = (fieldName, val) => {
    addDriverForm.setFieldValue(fieldName, val);
    setFormValues((prev) => ({
      ...prev,
      [fieldName]: val,
    }));
    if (fieldName == "countryCode") {
      debugger;
      setMinMaxMobileNoLength(getMinAndMaxLengthForMobileNumber(val));
    }

    addDriverForm.validateFields([fieldName]);
  };

  const buildPayload = (values) => {
    debugger;
    const hasAnyFilledFields = (visaObj) => {
      return (
        (visaObj?.documentNumber && visaObj.documentNumber.trim() !== "") ||
        (visaObj?.issuingCountry && visaObj.issuingCountry.trim() !== "") ||
        (visaObj?.expiryDate && visaObj.expiryDate.trim() !== "") ||
        (visaObj?.frontDoc?.fileName &&
          visaObj.frontDoc.fileName.trim() !== "") ||
        (visaObj?.frontDoc?.documentPath &&
          visaObj.frontDoc.documentPath.trim() !== "")
      );
    };
    let formattedVisa =
      visa
        ?.map((val) => ({
          ...val,
          documentNumber: val?.documentNumber ? val?.documentNumber : null,
          frontDoc: {
            // isInsertUpdate: val?.frontDoc?.isInsertUpdate,
            isPathSet: true,
            documentPath: val?.frontDoc?.documentPath || "",
            documentPathThumb: val?.frontDoc?.documentPathThumb || "",
            fileName: val?.frontDoc?.fileName,
            // *****  OCR NEW KEY ADDED
            isInsertUpdate: val?.frontDoc?.fileName
              ? val?.frontDoc?.isInsertUpdate
              : false,
            isOCRDoc: val?.frontDoc?.isOCRDoc,
          },
          expiryDate: val?.expiryDate
            ? moment(val?.expiryDate, format, true).isValid()
              ? moment(val?.expiryDate, format).format("YYYY-MM-DD")
              : moment(val?.expiryDate).format("YYYY-MM-DD")
            : null,
        }))
        .filter(hasAnyFilledFields) || [];
    let payload = {
      ocrLogId: ocrLogId || "", // New KEY OCR
      supplierId: supplierId ? supplierId : "",
      driverId: editformValues ? editformValues?.driverId : "",
      name: values?.driverName?.trim(),
      shipmentType: values.serviceType,
      assetPlatNumber: "",
      countryCode: values.countryCode,
      mobileNumber: values.mobileNumber,
      city: values.city,
      country: values.country,
      address: {
        location: addressDetail.address,
        latitude: addressDetail.latitude,
        longitude: addressDetail.longitude,
      },
      drivingLicense: {
        associateId: editformValues
          ? editformValues?.drivingLicense?.associateId
          : "",
        documentNumber: values.drivingLicenseNumber,
        expiryDate: moment(values.licenseExpiry, format).format("YYYY-MM-DD"),
        frontDoc: {
          // isInsertUpdate: values?.licenceFront?.isInsertUpdate,
          isPathSet: true,
          documentPath: values.licenceFront?.FileURL,
          documentPathThumb: values.licenceFront?.FileThumbURL,
          fileName: values.licenceFront.FileName,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: values?.licenceFront?.isInsertUpdate || false,
          isOCRDoc: values?.licenceFront?.isOCRDoc,
        },
        backDoc: {
          // isInsertUpdate: values?.licenceBack?.isInsertUpdate,
          isPathSet: true,
          documentPath: values.licenceBack?.FileURL,
          documentPathThumb: values.licenceBack?.FileThumbURL,
          fileName: values.licenceBack.FileName,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: values?.licenceBack?.isInsertUpdate || false,
          isOCRDoc: values?.licenceBack?.isOCRDoc,
        },
      },
      nationalID: {
        associateId: editformValues
          ? editformValues?.nationalID?.associateId
          : "",
        documentNumber: values.nationalId,
        expiryDate: moment(values.nationalIdExpiry, format).format(
          "YYYY-MM-DD"
        ),
        frontDoc: {
          // isInsertUpdate: values?.nationalIdFront?.isInsertUpdate,
          isPathSet: true,
          documentPath: values.nationalIdFront?.FileURL,
          documentPathThumb: values.nationalIdFront?.FileThumbURL,
          fileName: values.nationalIdFront.FileName,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: values?.nationalIdFront?.isInsertUpdate || false,
          isOCRDoc: values?.nationalIdFront?.isOCRDoc,
        },
        backDoc: {
          // isInsertUpdate: values?.nationalIdBack?.isInsertUpdate,
          isPathSet: true,
          documentPath: values.nationalIdBack?.FileURL,
          documentPathThumb: values.nationalIdBack?.FileThumbURL,
          fileName: values.nationalIdBack.FileName,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: values?.nationalIdBack?.isInsertUpdate || false,
          isOCRDoc: values?.nationalIdBack?.isOCRDoc,
        },
      },
      isMobileNumberVerified: values?.isMobileNumberVerified ? values?.isMobileNumberVerified :false ,
    };

    if (
      formValues?.serviceType?.length > 0 &&
      formValues?.serviceType.includes("Domestic") &&
      formValues?.serviceType?.length === 1
    ) {
      debugger;
    } else {
      payload = {
        ...payload,

        passport: {
          associateId: editformValues
            ? editformValues?.passport?.associateId
            : "",
          documentNumber: values.passportNumber ? values.passportNumber : "",
          expiryDate: moment(values.passportExpiry, format).format("YYYY-MM-DD")
            ? moment(values.passportExpiry, format).format("YYYY-MM-DD")
            : "",
          frontDoc: {
            // isInsertUpdate: values?.passportFront?.isInsertUpdate,
            isPathSet: true,
            documentPath: values.passportFront?.FileURL
              ? values.passportFront?.FileURL
              : "",
            documentPathThumb: values.passportFront?.FileThumbURL
              ? values.passportFront?.FileThumbURL
              : "",
            fileName: values.passportFront.FileName
              ? values.passportFront.FileName
              : "",
            // *****  OCR NEW KEY ADDED
            isInsertUpdate: values?.passportFront?.isInsertUpdate || false,
            isOCRDoc: values?.passportFront?.isOCRDoc,
          },
          backDoc: {
            // isInsertUpdate: values?.passportBack?.isInsertUpdate,
            isPathSet: true,
            documentPath: values.passportBack?.FileURL
              ? values.passportBack?.FileURL
              : "",
            documentPathThumb: values.passportBack?.FileThumbURL
              ? values.passportBack?.FileThumbURL
              : "",
            fileName: values.passportBack.FileName
              ? values.passportBack.FileName
              : "",
            // *****  OCR NEW KEY ADDED
            isInsertUpdate: values?.passportBack?.isInsertUpdate || false,
            isOCRDoc: values?.passportBack?.isOCRDoc,
          },
        },
        visa: formattedVisa,
      };
    }
    debugger;
    return payload;
  };

  const onSubmitHandler = async () => {
    const currentValues = addDriverForm.getFieldsValue();
    console.log("currentValues", currentValues);
    const mergedValues = { ...formValues, ...currentValues };
    const drivingLicenseNumber = mergedValues.drivingLicenseNumber;
    const nationalId = mergedValues.nationalId;
    const passportNumber = mergedValues.passportNumber;
    const visaNumbers = visa?.map((val) => val?.documentNumber) || [];

    if (
      passportNumber
        ? drivingLicenseNumber && nationalId && passportNumber
        : //  &&
          // visaNumbers?.length > 0
          drivingLicenseNumber && nationalId
    ) {
      if (
        passportNumber
          ? ((!removeUniquenessCheckForCountry(mergedValues?.country)) &&
              drivingLicenseNumber === nationalId) ||
            drivingLicenseNumber === passportNumber ||
            nationalId === passportNumber ||
            visaNumbers?.includes(drivingLicenseNumber) ||
            visaNumbers?.includes(nationalId) ||
            visaNumbers?.includes(passportNumber)
          : (!removeUniquenessCheckForCountry(mergedValues?.country)) &&
            drivingLicenseNumber === nationalId
      ) {
        Notification.error(
          t("DUPLICATE_DOC_NO_KEY"),
          t("DUPLICATE_DOC_VALIDATION")
        );
        return;
      }
    }
    if (visaNumbers?.length > 0) {
      const visaNumbersSet = new Set(visaNumbers);
      if (visaNumbersSet.size !== visaNumbers.length) {
        Notification.error(
          t("DUPLICATE_VISA_NO_KEY"),
          t("DUPLICATE_VISA_DOC_VALIDATION")
        );
        return;
      }
    }
    if (nextBtn) {
      addDriverForm
        .validateFields()
        .then(() => {
          setFormValues(mergedValues);
          setNextBtnTwo(true);
          debugger;
          setNextBtn(false);
        })
        .catch((error) => {
          setBtnLoader(false);
        });
    } else if (nextBtnTwo) {
      debugger;
      addDriverForm
        .validateFields()
        .then(() => {
          setBtnLoader(true);
          const payload = buildPayload(mergedValues);
          console.log("payload KJHGGHH", payload);
          debugger;

          driverService
            .addDriverOnboard(payload)
            .then((res) => {
              if (res?.status === 200) {
                if (formType === "editForm") {
                  Notification.success(
                    t("SUCCESS_KEY"),
                    t("DRIVING_UPDATED_SUCCESS")
                  );
                } else {
                  Notification.success(
                    t("SUCCESS_KEY"),
                    t("DRIVING_ADDED_TO_FLEET")
                  );
                }

                refresh();
                setBtnLoader(false);
                onClose();
                setDrivers([]);
              }
            })
            .catch((error) => {
              setBtnLoader(false);
            });
        })
        .catch((error) => {
          // addDriverForm.scrollToField(error.errorFields[0].name[0]);
        });
    } else {
      const values = addDriverForm.getFieldsValue();
      addDriverForm
        .validateFields()
        .then(() => {
          const payload = {
            countryCode: values?.countryCode,
            mobileNumber: values?.mobileNumber,
            supplierId: supplierId ? supplierId : "",
          };
          setBtnLoader(true);
          driverService
            .CheckDriverExist(payload)
            .then((response) => {
              if (response?.data?.data === "") {
                setBtnLoader(false);
                const countryFilter = mobileCountryCodeList.find(
                  (item) => item.phone_code === values?.countryCode
                );
                // const findCountryCode = countryOptions.find((item)=>item.name === countryFilter.name)
                addDriverForm.setFieldsValue({
                  country: countryFilter.name,
                  mobileNumber: values.mobileNumber,
                });
                getCityList(countryFilter?.country_code);
                debugger;

                // setNextBtn(true);
                setIsOcrFileUpload(true);
                setVerifyMobile(true);
              } else if (response?.data?.data) {
                setBtnLoader(false);
                setDriverId(response?.data?.data);
                setDriverExist(true);
              }
            })
            .catch((err) => {
              setBtnLoader(false);
              // onClose();
            });
        })
        .catch((error) => {
          addDriverForm.scrollToField(error.errorFields[0].name[0]);
        });
    }
    // })
  };

  const addDriverinFleetHandler = () => {
    if (addFleet) {
      debugger;
      setBtnLoader(true);
      const payload = {
        externalDriverId: driverId,
        supplierId: supplierId ? supplierId : "",
      };
      driverService
        .addDriverInFleet(payload)
        .then((response) => {
          if (response?.data) {
            setBtnLoader(false);
            Notification.success(t("SUCCESS_KEY"), t("DRIVING_ADDED_TO_FLEET"));
            onClose();
            setDrivers([]);
            refresh();
          }
        })
        .catch((err) => {
          setBtnLoader(false);
        });
    } else {
      setBtnLoader(true);
      driverService
        .getDriverById(driverId)
        .then((response) => {
          if (response?.data) {
            setBtnLoader(false);
            setDriverData(response?.data?.data);
            const { drivingLicense, nationalID, passport, visa } =
              response?.data?.data || {};

            // Combine all documents into one array
            const allDocs = [
              { type: "Driving License", ...drivingLicense },
              { type: "National ID", ...nationalID },
              { type: "Passport", ...passport },
              ...visa.map((v) => ({ type: "Visa", ...v })),
            ];

            // Save the combined documents
            setDriverDocs(allDocs);
            setAddFleet(true);
          }
        })
        .catch((err) => {
          setBtnLoader(false);
        });
    }
  };

  const onFileUploadDocs = (file, fieldName) => {
    var updatedInquiryDocs = [...frontDocs];
    updatedInquiryDocs[0] = {
      docType: file.docType,
      fileName: file.FileName,
      fileThumbName: file.FileThumbName,
      fileUrl: file.FileURL,
      // isInsertUpdate: true,
      size: file.size,
      EntityId: file.EntityId,
      fileThumbUrl: file.FileThumbURL,
      fileData: file.FileData,
      // *****  OCR NEW KEY ADDED
      isInsertUpdate: true,
      isOCRDoc: false,
    };
    setFrontDocs(updatedInquiryDocs);
    addDriverForm.setFieldsValue({
      [fieldName]: {
        DocType: file.docType,
        FileName: file.FileName,
        FileThumbName: file.FileThumbName,
        FileUrl: file.FileURL,
        // isInsertUpdate: true,
        isPathSet: true,
        EntityId: file.EntityId,
        FileThumbUrl: file.FileThumbURL,
        // *****  OCR NEW KEY ADDED
        isInsertUpdate: true,
        isOCRDoc: false,
      },
    });
    // setFormValues((prev) => ({
    //   ...prev,
    //   [fieldName]: {
    //     FileName: file?.FileName,
    //     FileURL: file?.FileURL,
    //     FileThumbURL: file?.FileThumbURL,
    //     isInsertUpdate: true,
    //     isPathSet: true
    //   },
    // }));
  };

  // ***************** OCR FILE UPLOAD HANDLED *******************
  const handleFileChange = (newFiles) => {
    setUploadedFileData((prev) => [...prev, ...newFiles]);
  };

  const handleFileDelete = (fileNameToDelete) => {
    setUploadedFileData((prev) =>
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete)
    );
  };

  const handleOCRConformFileChange = (newFiles) => {
    console.log("handleOCRConformFileChange", newFiles);
    setOcrConfirmedFiles((prev) => [...prev, ...newFiles]);
  };

  const handleOCRConfirmFileDelete = (fileNameToDelete) => {
    setOcrConfirmedFiles((prev) =>
      // prev.filter((_, index) => index !== indexToDelete)
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete)
    );
    setUploadedFileData((prev) =>
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete)
    );
  };

  const handleViewSampleClick = (type) => {
    console.log("handleViewSampleClick type", type);
    setSampleType(type);
    setSamplePreviewOpen(true);
  };

  const onClickProceed = () => {
    if (uploadedFileData.length === 0) {
      Notification.warning("Warning", "Please upload at least one document.");
      return;
    }

    setOcrConfirmedFiles([...uploadedFileData]);
    // setIsUploadingPopupVisible(true);
  };

  const config = {
    onUploadProgress: function (progressEvent) {
      console.log("progressEvent.total", progressEvent.total);
      console.log("progressEvent.loaded", progressEvent.loaded);
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );

      setUploadState((prev) => {
        let status = "";
        let description = "";

        if (!prev.started) {
          status = t("OCR_MODAL_HOLD_TIGHT_MSG");
          description = t("OCR_MODAL_DO_NOT_CLOSE_MSG");
        } else if (percentCompleted < 30) {
          status = t("OCR_MODAL_HOLD_TIGHT_MSG");
          description = t("OCR_MODAL_DO_NOT_CLOSE_MSG");
        } else if (percentCompleted < 70) {
          status = t("OCR_MODAL_ALMOST_THERE_MSG");
          description = t("OCR_MODAL_RIGHT_PLACE_MSG");
        } else if (percentCompleted < 100) {
          status = t("OCR_MODAL_FINAL_STEP");
          description = t("OCR_MODAL_HANG_ON_MSG");
        } else {
          status = t("OCR_MODAL_FINAL_STEP");
          description = t("OCR_MODAL_HANG_ON_MSG");
        }

        return {
          progress: percentCompleted,
          status,
          description,
          started: true,
        };
      });
    },
  };

  const uploadToOCR = async () => {
    if (!ocrConfirmedFiles || ocrConfirmedFiles.length === 0) return;

    const parserAppMap = {
      // truck: process.env.REACT_APP_OCR_ASSET,
      // fleet: process.env.REACT_APP_OCR_SHIPPER_SUPPLIER,
      // driver: process.env.REACT_APP_OCR_DRIVER_STO,
      truck: "RDLj2vIouDleRWu0",
      fleet: "mCFBiv6Hcl8U02Sp",
      // driver: "2p1fqkPj0wFL9T0E",
      driver: "testqkPj0wFL9T0E",
    };
    // const parserApp = parserAppMap["fleet"] || "";
    const parserKey = ownerType === "IndividualOwner" ? "driver" : "fleet";
    const parserApp = parserAppMap[parserKey] || "";
    console.log("parserApp", parserApp);
    const form = new FormData();
    // form.append("file", uploadedFileData.file);

    ocrConfirmedFiles.forEach((item) => {
      if (item?.file) {
        form.append("files", item.file);
      }
    });
    form.append("parserApp", parserApp);
    form.append("userType", "Driver");
    form.append("countryCode", String(formValues.countryCode || ""));
    form.append("entityType",EntityTypes.DRIVER);
    // form.append("model", "v1");
    // form.append("extra_accuracy", "false");
    try {
      console.log("Sending to OCR", form.getAll("files"), parserApp);
      const response = await ocrCustomFileUploadService(form, config);
      console.log("OCR Upload Response:", response);
      const parsedData = response?.data?.data?.parsedData;
      // const ocrLogId = response?.data?.data?.ocrLogId;
      const newOcrLogId  = response?.data?.data?.ocrLogId;
      if (parsedData && newOcrLogId) {
        console.log("uploadToOCR parsedData", parsedData);
        setOcrParsedData(parsedData);
        // setOcrLogId(ocrLogId);
        setOcrLogId(prev =>
          prev ? `${prev},${newOcrLogId}` : String(newOcrLogId)
        );
        return parsedData;
      } else {
        console.warn("No parsedData in OCR response");
        // setOcrLogId("");
      }
    } catch (error) {
      console.error("OCR Upload Failed:", error);
      let message =
        error?.response?.data?.message ||
        "OCR upload failed due to a server error. Please try again.";
      if (typeof message === "object") {
        message = message?.description || JSON.stringify(message);
      }
      Notification.error("Document Upload Error", {
        description: `${message} You can retry uploading the document.`,
      });

      console.log("Notification.error message", message);
    }
  };

  const isOcrDataValid = (ocrParsedData) => {
    console.log("isOcrDataValid before", ocrParsedData);
    console.log("isOcrDataValid before ocrParsedData", !ocrParsedData);
    console.log(
      "isOcrDataValid before !ocrParsedData?.documents",
      !ocrParsedData?.documents
    );
    debugger;
    if (!ocrParsedData || !ocrParsedData?.documents) {
      return false;
    }

    return ocrParsedData.documents.every((doc) => {
      console.log(
        "isOcrDataValid",
        doc.status,
        Array.isArray(doc.errors),
        doc.errors?.length === 0
      );

      return (
        doc.status === true &&
        Array.isArray(doc.errors) &&
        doc.errors?.length === 0
      );
    });
  };

  // **** Before -- Submit to upload DOC to OCR Only
  // const onClickSubmit = async () => {
  //   setIsUploadingPopupVisible(true);
  //   // await uploadToOCR();
  //   const parsedData = await uploadToOCR();

  //   setIsUploadingPopupVisible(false);
  //   setUploadState(initialUploadState);
  //   // Check for OCR data Has No Errors
  //   if (isOcrDataValid(parsedData)) {
  //     // setCurrentStep(SignUpSteps.BASIC_INFO);
  //     setIsOcrFileUpload(false);
  //     setNextBtn(true);
  //   } else {
  //     console.warn(
  //       "Validation failed: Some documents have errors or status is false."
  //     );
  //   }
  // };
  // ****** After -- add Missing modal to submit Button
  const onClickSubmit = async () => {
    if (ocrParsedData && !isOcrDataValid(ocrParsedData)) {
      setMissingDocModal(true);
      return;
    }

    setIsUploadingPopupVisible(true);
    // await uploadToOCR();
    const parsedData = await uploadToOCR();

    setIsUploadingPopupVisible(false);
    setUploadState(initialUploadState);
    // Check for OCR data Has No Errors
    if (isOcrDataValid(parsedData)) {
      // setCurrentStep(SignUpSteps.BASIC_INFO);
      setIsOcrFileUpload(false);
      setNextBtn(true);
    } else {
      console.warn(
        "Validation failed: Some documents have errors or status is false."
      );
    }
  };

  const handleDrawerFileSubmit = async () => {
    setIsUploadingPopupVisible(true);
    // await uploadToOCR();
    const parsedData = await uploadToOCR();
    setIsUploadingPopupVisible(false);
    setUploadState(initialUploadState);
    if (isOcrDataValid(parsedData)) {
      // setCurrentStep(SignUpSteps.BASIC_INFO);
      setIsOcrFileUpload(false);
      setNextBtn(true);
      setOpenDrawer(false);
    } else {
      console.warn(
        "Validation failed: Some documents have errors or status is false."
      );
    }
  };

  const onSkipSectionChange = () => {
    if (!ocrParsedData) {
      if (ocrConfirmedFiles.length > 0) {
        // Notification.warning(
        //   "Files Not Submitted",
        //   "No files were uploaded. Proceeding to the next step."
        // );
        // setMissingDocModal(true);
        setIsDiscardModalVisible(true);
      } else {
        setNextBtn(true);
        setIsOcrFileUpload(false);
      }
    } else {
      // Parsed data exists — show modal for missing documents
      // setMissingDocModal(true);
      setIsDiscardModalVisible(true);
    }
  };

  const handleProceedDiscardOcrData = () => {
    setIsDiscardModalVisible(false);
    setMissingDocModal(false);
    setNextBtn(true);

    // Reset OCR-related states
    setUploadedFileData([]);
    setOcrConfirmedFiles([]);
    setOcrParsedData(null);
    setOcrLogId("");
    setUploadState(initialUploadState);
  };

  // ****************** OCR EDIT  *****************
  const OCRFieldNames = {
    VAT_CERTIFICATE: "VAT_CERTIFICATE",
    TRADE_LICENSE: "TRADE_LICENSE",
    DRIVING_LICENSE: "DRIVING_LICENSE",
    PASSPORT: "PASSPORT",
    NATIONAL_ID: "NATIONAL_ID",
    VISA: "VISA",
  };

  const ocrFieldToStateKey = {
    [OCRFieldNames.VAT_CERTIFICATE]: "vatCertificate",
    [OCRFieldNames.TRADE_LICENSE]: "tradeLicense",
    [OCRFieldNames.DRIVING_LICENSE]: "drivingLicense",
    [OCRFieldNames.PASSPORT]: "passport",
    [OCRFieldNames.NATIONAL_ID]: "nationalID",
    [OCRFieldNames.VISA]: "visa",
  };

  const uploadDirectToCloud = async (
    fileWrapper,
    fieldName,
    ocrFieldName,
    fileType,
    index
  ) => {
    const actualFile = fileWrapper.file ?? fileWrapper;

    const form = new FormData();
    form.append("file", actualFile);

    const payload = {
      docType: fileType,
      entityType: EntityTypes.SUPPLIER,
      fileName: actualFile.name,
      docName: actualFile.name ? actualFile.name.replace(/\s+/g, "_") : "",
      fileData: "",
      fileURL: "",
      fileThumbURL: "",
      fileThumbName: "",
      uniqueID: "",
      totalPartition: 1,
      seq: 1,
      isPathSet: true,
    };

    form.append("details", JSON.stringify(payload));

    try {
      const response = await uploadDocumentV2(form, config);
      if (response.data.status === 200) {
        const data = response.data.data;
        console.log("uploadDocumentV2 data", data);

        // // call same flow as onFileUploadDocs
        // editSupplierForm.setFieldsValue({
        //   [fieldName]: {
        //     docType: data.docType,
        //     fileName: data.fileName,
        //     fileThumbName: data.fileThumbName,
        //     isInsertUpdate: true,
        //     fileUrl: data.fileURL,
        //     isPathSet: true,
        //     fileThumbUrl: data.fileThumbURL,
        //   },
        // });

        const stateKey = ocrFieldToStateKey[ocrFieldName];
        console.log("stateKey", stateKey);

        // setEditSupplierDocs((prev) => ({
        //   ...prev,
        //   [stateKey]: {
        //     ...prev?.[stateKey],
        //     frontDoc: {
        //       ...prev?.[stateKey]?.frontDoc,
        //       documentPath: data.fileURL || null,
        //       documentPathThumb: data.fileThumbURL || null,
        //       fileName: data.fileName || null,
        //     },
        //   },
        // }));

        // decide whether it's a backDoc upload
        //  **********************
        // const isBackDoc =
        //   fieldName?.toLowerCase().includes("back") &&
        //   (ocrFieldName === OCRFieldNames.DRIVING_LICENSE ||
        //     ocrFieldName === OCRFieldNames.NATIONAL_ID ||
        //     ocrFieldName === OCRFieldNames.PASSPORT);

        // setFormValues((prev) => ({
        //   ...prev,
        //   [fieldName]: {
        //     ...prev?.[fieldName],
        //     FileName: data.fileName || "",
        //     FileThumbName: data.fileThumbName || "",
        //     FileURL: data.fileURL || "",
        //     FileThumbURL: data.fileThumbURL || "",
        //     isPathSet: true,
        //     isInsertUpdate: true,
        //     isOCRDoc: false,
        //   },
        // }));

        // const normalizedFile = {
        //   docType: data.docType,
        //   EntityId: data.entityId,
        //   FileName: data.fileName,
        //   FileThumbName: data.fileThumbName,
        //   FileThumbURL: data.fileThumbURL,
        //   FileURL: data.fileURL,
        //   Status: data.status ?? false,
        // };

        // console.log("normalizedFile", normalizedFile);

        // onFileUploadDocs(normalizedFile, fieldName);
        // *******************************
        if (ocrFieldName === OCRFieldNames.VISA && index !== null) {
          let localVisa = [...visa];
          localVisa[index].frontDoc = {
            ...localVisa[index].frontDoc,
            fileName: data.fileName || "",
            documentPath: data.fileURL || "",
            documentPathThumb: data.fileThumbURL || "",
            isInsertUpdate: true,
            isOCRDoc: false,
          };

          setVisa(localVisa);
          handleFormChange("visa", localVisa);
        } else {
          const isBackDoc =
            fieldName?.toLowerCase().includes("back") &&
            (ocrFieldName === OCRFieldNames.DRIVING_LICENSE ||
              ocrFieldName === OCRFieldNames.NATIONAL_ID ||
              ocrFieldName === OCRFieldNames.PASSPORT);

          setFormValues((prev) => ({
            ...prev,
            [fieldName]: {
              ...prev?.[fieldName],
              FileName: data.fileName || "",
              FileThumbName: data.fileThumbName || "",
              FileURL: data.fileURL || "",
              FileThumbURL: data.fileThumbURL || "",
              isPathSet: true,
              isInsertUpdate: true,
              isOCRDoc: false,
            },
          }));

          const normalizedFile = {
            docType: data.docType,
            EntityId: data.entityId,
            FileName: data.fileName,
            FileThumbName: data.fileThumbName,
            FileThumbURL: data.fileThumbURL,
            FileURL: data.fileURL,
            Status: data.status ?? false,
          };

          console.log("normalizedFile", normalizedFile);

          onFileUploadDocs(normalizedFile, fieldName);
        }

        Notification.success(t("SUCCESS_KEY"), t("FILE_UPLOADED_SUCCESS"));
      } else {
        Notification.error(response.data.message || "Upload failed");
      }
    } catch (error) {
      console.error("uploadDirectToJCloud error", error);
      Notification.error(t("ERROR_MESSAGE"));
    }
  };

  const ocrMappedData = (ocrFieldName, doc, index) => {
    console.log("ocrMappedData doc", doc);
    console.log("ocrMappedData ocrFieldName", doc);
    switch (ocrFieldName) {
      case "DRIVING_LICENSE": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedDLExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const frontDoc = {
          EntityId: EntityTypes.DRIVER,
          FileName:
            `ActualDriver/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          FileThumbURL: documentUtility.getThumbnailImagePath(frontUrl) || null,
          FileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          FileURL: frontUrl || null,
          FileUrl: frontUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const backDoc = {
          EntityId: EntityTypes.DRIVER,
          FileName:
            `ActualDriver/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          FileThumbURL: backUrl || null,
          FileThumbUrl: backUrl || null,
          FileURL: backUrl || null,
          FileUrl: backUrl || null,
          Status: false,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          drivingLicenseNumber: docNumber || undefined,
          licenseExpiry: parsedDLExpiry,
          licenceFront: frontDoc,
          licenceBack: backDoc,
        }));

        addDriverForm.setFieldsValue({
          drivingLicenseNumber: docNumber || undefined,
          licenseExpiry: parsedDLExpiry,
          licenceFront: frontDoc,
          licenceBack: backDoc,
        });
        break;
      }

      case "NATIONAL_ID": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedNationalIdExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const nationalIdFront = {
          EntityId: EntityTypes.DRIVER,
          DocType: "NIDFD",
          FileName:
            `ActualDriver/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          FileThumbURL: documentUtility.getThumbnailImagePath(frontUrl) || null,
          FileURL: frontUrl || null,
          Status: false,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const nationalIdBack = {
          EntityId: EntityTypes.DRIVER,
          DocType: "NIDBD",
          FileName:
            `ActualDriver/${ocrLogId}_NIDBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_NIDBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          FileThumbURL: backUrl || null,
          FileURL: backUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          nationalId: docNumber || undefined,
          nationalIdExpiry: parsedNationalIdExpiry,
          nationalIdFront,
          nationalIdBack,
        }));

        addDriverForm.setFieldsValue({
          nationalId: docNumber || undefined,
          nationalIdExpiry: parsedNationalIdExpiry,
          nationalIdFront: nationalIdFront,
          nationalIdBack: nationalIdBack,
        });
        break;
      }

      case "PASSPORT": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedPassportExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const passportFront = {
          DocType: "PASSFD",
          EntityId: EntityTypes.DRIVER,

          FileName:
            `ActualDriver/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          FileThumbURL: documentUtility.getThumbnailImagePath(frontUrl) || null,
          FileURL: frontUrl || null,
          Status: false,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const passportBack = {
          DocType: "PASSBD",
          EntityId: EntityTypes.DRIVER,
          FileName:
            `ActualDriver/${ocrLogId}_PASSBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          FileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_PASSBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          FileThumbURL: backUrl || null,
          FileURL: backUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          passportNumber: docNumber || undefined,
          passportExpiry: parsedPassportExpiry,
          passportFront: passportFront,
          passportBack: passportBack,
        }));

        addDriverForm.setFieldsValue({
          passportNumber: docNumber || undefined,
          passportExpiry: parsedPassportExpiry,
          passportFront: passportFront,
          passportBack: passportBack,
        });
        break;
      }

      case "VISA": {
        const { docNumber, docExpiryDate, frontUrl, issueCountry } = doc;
        const parsedVisaExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").isValid()
            ? dayjs(docExpiryDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : docExpiryDate
          : "";

        const visaFront = {
          fileName:
            `ActualDriver/${ocrLogId}_VISA${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          documentPath: frontUrl || null,
          documentPathThumb:
            documentUtility.getThumbnailImagePath(frontUrl) || null,
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        if (index !== null && index !== undefined) {
          let localVisa = [...visa];
          localVisa[index] = {
            ...localVisa[index],
            documentNumber: docNumber || "",
            issuingCountry: issueCountry || "",
            expiryDate: parsedVisaExpiry,
            frontDoc: visaFront,
          };

          setVisa(localVisa);
          handleFormChange("visa", localVisa);
        }

        break;
      }

      default: {
        console.warn(
          `No mapping found in ocrMappedData for docType: ${ocrFieldName}`,
          doc
        );

        break;
      }
    }
  };

  const uploadEditToOCR = async (ocrConfirmedFiles) => {
    if (!ocrConfirmedFiles || ocrConfirmedFiles.length === 0) return;

    const parserAppMap = {
      // truck: process.env.REACT_APP_OCR_ASSET,
      // fleet: process.env.REACT_APP_OCR_SHIPPER_SUPPLIER,
      // driver: process.env.REACT_APP_OCR_DRIVER_STO,
      truck: "RDLj2vIouDleRWu0",
      fleet: "mCFBiv6Hcl8U02Sp",
      // driver: "2p1fqkPj0wFL9T0E",
      driver: "testqkPj0wFL9T0E",
    };
    // const parserApp = parserAppMap["fleet"] || "";
    const parserKey = ownerType === "IndividualOwner" ? "driver" : "fleet";
    const parserApp = parserAppMap[parserKey] || "";
    console.log("parserApp", parserApp);
    const form = new FormData();
    // form.append("file", uploadedFileData.file);

    ocrConfirmedFiles.forEach((item) => {
      if (item?.file) {
        form.append("files", item.file);
      }
    });
    form.append("parserApp", parserApp);
    form.append("userType", "Driver");
    form.append("countryCode", String(formValues.countryCode || ""));
    form.append("entityType",EntityTypes.DRIVER);
    // form.append("model", "v1");
    // form.append("extra_accuracy", "false");
    try {
      console.log("Sending to OCR", form.getAll("files"), parserApp);
      const response = await ocrCustomFileUploadService(form, config);
      const parsedData = response?.data?.data?.parsedData;
      // const ocrLogId = response?.data?.data?.ocrLogId;
      const newOcrLogId  = response?.data?.data?.ocrLogId;
      if (parsedData && newOcrLogId) {
        console.log("uploadToOCR parsedData", parsedData);
        setOcrParsedData(parsedData);
        // setOcrLogId(ocrLogId);
        setOcrLogId(prev =>
          prev ? `${prev},${newOcrLogId}` : String(newOcrLogId)
        );
        return parsedData;
      } else {
        console.warn("No parsedData in OCR response");
        // setOcrLogId("");
      }
    } catch (error) {
      console.error("OCR Upload Failed:", error);
      const message =
        error?.response?.data?.message ||
        "OCR upload failed due to a server error.";
      Notification.error("Upload Failed", message);
    }
  };

  const handleEditOCRConformFileChange = async (
    newFiles,
    fieldName,
    ocrFieldName,
    fileType,
    index = null
  ) => {
    if (!newFiles || newFiles.length === 0) return;

    console.log("handleOCRConformFileChange newFiles", newFiles[0]);
    console.log("handleOCRConformFileChange fieldName", fieldName);

    setUploadState(initialUploadState);
    setIsUploadingPopupVisible(true);

    let responseParseData = null;
    try {
      // Calling the OCR API function to fetch OCR data
      responseParseData = await uploadEditToOCR(newFiles);
    } catch (error) {
      console.error("OCR failed, will fallback to direct upload", error);
    }

    // IF Data is From OCR and Data is Correct as per ocrFieldName
    if (responseParseData?.documents?.length) {
      const documents = responseParseData.documents;
      const matchedDoc = documents.find(
        (doc) => doc.docType === ocrFieldName && doc.status === true
      );

      if (matchedDoc) {
        ocrMappedData(ocrFieldName, matchedDoc, index);
        debugger;
        setIsUploadingPopupVisible(false);
        return;
      }
    }

    //  OCR failed or didn’t match → direct upload to Cloud
    try {
      debugger;
      await uploadDirectToCloud(
        newFiles[0],
        fieldName,
        ocrFieldName,
        fileType,
        index
      );
    } catch (err) {
      console.error("Direct upload failed too:", err);
    } finally {
      setIsUploadingPopupVisible(false); // close popup after cloud upload
    }
  };

  const handleEditingDeleteFile = (fieldName, ocrFieldName) => {
    console.log("handleEditingDeleteFile", fieldName);

    setFormValues((prev) => {
      const updated = { ...prev };

      if (["truckRegBack", "trailerDocBack"].includes(fieldName)) {
        updated[fieldName] = {
          ...prev?.[fieldName],
          FileName: "",
          FileThumbName: "",
          FileURL: "",
          FileThumbURL: "",
          isPathSet: false,
          isInsertUpdate: false,
          isOCRDoc: false,
        };
      } else {
        updated[fieldName] = {
          ...prev?.[fieldName],
          FileName: "",
          FileThumbName: "",
          FileURL: "",
          FileThumbURL: "",
          isPathSet: false,
          isInsertUpdate: false,
          isOCRDoc: false,
        };
      }

      return updated;
    });
  };

  const handleVisaDeleteFileUpload = (index) => {
    setVisa((prev) => {
      const updatedVisa = [...prev];

      updatedVisa[index].frontDoc = {
        fileName: "",
        documentPath: "",
        documentPathThumb: "",
        isInsertUpdate: false,
        isOCRDoc: false,
        isPathSet: false,
      };

      return updatedVisa;
    });
  };

  if (!isOpen) return null;

  return (
    <>
      <Modal
        open={isOpen}
        centered
        maskClosable={false}
        onCancel={() => {
          setNextBtn(false);
          onClose();
        }}
        width={
          addFleet
            ? "70rem"
            : nextBtn
            ? "35rem"
            : nextBtnTwo
            ? "40rem"
            : "32rem"
        }
        title={
          <div>
            {formType === "editForm"
              ? t("FLEET_EDIT_DRIVER_LBL")
              : driverExist && !addFleet
              ? t("DRIVER_ALREADY_EXIST_MSG")
              : t("FLEET_ADD_NEW_DRIVER_LBL")}{" "}
            <span className="title-span"></span>
          </div>
        }
        footer={false}
      >
        <div className="add-modal-form" style={{ maxHeight: "80vh" }}>
          <Divider />
          {!driverExist ? (
            <Form layout="vertical" form={addDriverForm} className="ant-form">
              {nextBtnTwo ? (
                <div className="truck-form-scroll">
                  {/* ******** Driving Licenece********** */}
                  <span className="star-color">
                    {t("FLEET_DRIVER_DRIVING_LICENSE")} <span>*</span>
                  </span>
                  <Row gutter={16}>
                    <Col span={12}>
                      {formType !== "editForm" && (
                        <Form.Item
                          name="licenceFront"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("UPLOAD_LICENCE_FRONT_REQUIRED"),
                            },
                          ]}
                        >
                          <Fileupload
                            filetype={DocTypes.DL_FRONT}
                            defaultThumbFile={
                              formValues?.licenceFront
                                ? formValues?.licenceFront?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.licenceFront
                                ? formValues?.licenceFront?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.licenceFront
                                ? formValues?.licenceFront?.FileName
                                : frontDocs?.FileName
                            }
                            entityId=""
                            entityType={EntityTypes.DRIVER}
                            accessFile={true}
                            name={t("KYC_UPLOAD_FRONT_LBL")}
                            onChange={(value) => {
                              onFileUploadDocs(value, "licenceFront");
                            }}
                            // updateFormValue={(val) => {
                            //   addDriverForm.setFieldsValue({ licenceFront: val });
                            // }}
                          />
                        </Form.Item>
                      )}
                      {/* **** licenceFront OCR File Driving Licenece ***** */}
                      {formType === "editForm" && (
                        <Form.Item
                          name="licenceFront"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("UPLOAD_LICENCE_FRONT_REQUIRED"),
                            },
                          ]}
                          valuePropName="value"
                          getValueFromEvent={(e) => {
                            // if your component emits [ { file, fileThumbUrl } ]
                            if (Array.isArray(e) && e.length > 0) {
                              return {
                                // File: e[0].file,
                                // FileThumbURL: e[0].fileThumbUrl,
                              };
                            }
                            return e;
                          }}
                        >
                          <OCRFilePreviewUploader
                            filetype={DocTypes.DL_FRONT}
                            defaultThumbFile={
                              formValues?.licenceFront
                                ? formValues?.licenceFront?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.licenceFront
                                ? formValues?.licenceFront?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.licenceFront
                                ? formValues?.licenceFront?.FileName
                                : frontDocs?.FileName
                            }
                            entityId=""
                            entityType={EntityTypes.DRIVER}
                            accessFile={true}
                            name={t("KYC_UPLOAD_FRONT_LBL")}
                            // onChange={(value) => {
                            //   onFileUploadDocs(value, "vatUpload");
                            // }}
                            onChange={(newFiles) =>
                              handleEditOCRConformFileChange(
                                newFiles,
                                "licenceFront",
                                OCRFieldNames.DRIVING_LICENSE,
                                DocTypes.DL_FRONT
                              )
                            }
                            onDelete={() =>
                              handleEditingDeleteFile(
                                "licenceFront",
                                OCRFieldNames.DRIVING_LICENSE
                              )
                            }
                          />
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={12}>
                      {formType !== "editForm" && (
                        <Form.Item
                          name="licenceBack"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("UPLOAD_LICENCE_BACK_REQUIRED"),
                            },
                          ]}
                        >
                          <Fileupload
                            filetype={DocTypes.DL_BACK}
                            defaultThumbFile={
                              formValues?.licenceBack
                                ? formValues?.licenceBack?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.licenceBack
                                ? formValues?.licenceBack?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.licenceBack
                                ? formValues?.licenceBack?.FileName
                                : frontDocs?.FileName
                            }
                            entityId=""
                            entityType={EntityTypes.DRIVER}
                            accessFile={true}
                            name={t("KYC_UPLOAD_BACK_LBL")}
                            onChange={(value) => {
                              onFileUploadDocs(value, "licenceBack");
                            }}
                            updateFormValue={(val) => {
                              addDriverForm.setFieldsValue({
                                licenceBack: val,
                              });
                            }}
                          />
                        </Form.Item>
                      )}
                      {formType === "editForm" && (
                        <Form.Item
                          name="licenceBack"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("UPLOAD_LICENCE_BACK_REQUIRED"),
                            },
                          ]}
                          valuePropName="value"
                          getValueFromEvent={(e) => {
                            // if your component emits [ { file, fileThumbUrl } ]
                            if (Array.isArray(e) && e.length > 0) {
                              return {
                                // File: e[0].file,
                                // FileThumbURL: e[0].fileThumbUrl,
                              };
                            }
                            return e;
                          }}
                        >
                          <OCRFilePreviewUploader
                            filetype={DocTypes.DL_BACK}
                            defaultThumbFile={
                              formValues?.licenceBack
                                ? formValues?.licenceBack?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.licenceBack
                                ? formValues?.licenceBack?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.licenceBack
                                ? formValues?.licenceBack?.FileName
                                : frontDocs?.FileName
                            }
                            entityId=""
                            entityType={EntityTypes.DRIVER}
                            accessFile={true}
                            name={t("KYC_UPLOAD_BACK_LBL")}
                            // onChange={(value) => {
                            //   onFileUploadDocs(value, "vatUpload");
                            // }}
                            onChange={(newFiles) =>
                              handleEditOCRConformFileChange(
                                newFiles,
                                "licenceBack",
                                OCRFieldNames.DRIVING_LICENSE,
                                DocTypes.DL_BACK
                              )
                            }
                            onDelete={() =>
                              handleEditingDeleteFile(
                                "licenceBack",
                                OCRFieldNames.DRIVING_LICENSE
                              )
                            }
                          />
                        </Form.Item>
                      )}
                    </Col>
                  </Row>
                  <Form.Item
                    name="drivingLicenseNumber"
                    rules={[
                      {
                        required: true,
                        message: t("DRIVING_LICENCE_NO_REQUIRED"),
                      },
                      { validator: validateNotEmpty("driving license number") },
                    ]}
                    className="floating-label-form-item"
                  >
                    <Input
                      value={formValues?.drivingLicenseNumber}
                      style={{ width: "100%" }}
                      className="floating-input"
                      placeholder={t("DRIVING_LICENSE_PLACEHOLDER")}
                      maxLength={20}
                      onChange={(e) =>
                        handleFormChange("drivingLicenseNumber", e.target.value)
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_DRIVER_DRIVING_LICENSE_NO")} <span>*</span>
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="licenseExpiry"
                    rules={[
                      {
                        required: true,
                        message: t("EXPIRY_DATE_REQUIRED"),
                      },
                    ]}
                    className="floating-label-form-item"
                  >
                    <DatePicker
                      className="floating-input"
                      format={format}
                      placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                      disabledDate={disablePastDates}
                      value={
                        formValues?.licenseExpiry
                          ? dayjs(formValues.licenseExpiry, format)
                          : null
                      }
                      onChange={(date, dateString) => {
                        console.log(
                          "ADD DRVIER licenseExpiry DatePicker  onChange"
                        );
                        console.log(
                          "ADD DRVIER licenseExpiry DatePicker  onChange",
                          formValues?.licenseExpiry
                            ? dayjs(formValues.licenseExpiry, format)
                            : null
                        );
                        handleFormChange("licenseExpiry", dateString);
                      }}
                    />
                    <label className="floating-label">
                      {t("FLEET_DRIVER_EXPIRY_DATE")} <span>*</span>
                    </label>
                  </Form.Item>
                  {/* **************** NAtional ID **************** */}
                  <span className="star-color">
                    {t("FLEET_DRIVER_NATIONAL_ID")} <span>*</span>
                  </span>
                  <Row gutter={16}>
                    <Col span={12}>
                      {formType !== "editForm" && (
                        <Form.Item
                          name="nationalIdFront"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("NATIONAL_ID_FRONT_UPLOAD_REQUIRED"),
                            },
                          ]}
                        >
                          <Fileupload
                            filetype={DocTypes.NATIONAL_ID_FRONT}
                            defaultThumbFile={
                              formValues?.nationalIdFront
                                ? formValues?.nationalIdFront?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.nationalIdFront
                                ? formValues?.nationalIdFront?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.nationalIdFront
                                ? formValues?.nationalIdFront?.FileName
                                : frontDocs?.FileName
                            }
                            entityId=""
                            entityType={EntityTypes.DRIVER}
                            accessFile={false}
                            name={t("KYC_UPLOAD_FRONT_LBL")}
                            onChange={(value) => {
                              onFileUploadDocs(value, "nationalIdFront");
                            }}
                            updateFormValue={(val) => {
                              addDriverForm.setFieldsValue({
                                nationalIdFront: val,
                              });
                            }}
                          />
                        </Form.Item>
                      )}
                      {formType === "editForm" && (
                        <Form.Item
                          name="nationalIdFront"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("NATIONAL_ID_FRONT_UPLOAD_REQUIRED"),
                            },
                          ]}
                          valuePropName="value"
                          getValueFromEvent={(e) => {
                            // if your component emits [ { file, fileThumbUrl } ]
                            if (Array.isArray(e) && e.length > 0) {
                              return {
                                // File: e[0].file,
                                // FileThumbURL: e[0].fileThumbUrl,
                              };
                            }
                            return e;
                          }}
                        >
                          <OCRFilePreviewUploader
                            filetype={DocTypes.NATIONAL_ID_FRONT}
                            defaultThumbFile={
                              formValues?.nationalIdFront
                                ? formValues?.nationalIdFront?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.nationalIdFront
                                ? formValues?.nationalIdFront?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.nationalIdFront
                                ? formValues?.nationalIdFront?.FileName
                                : frontDocs?.FileName
                            }
                            entityId=""
                            entityType={EntityTypes.DRIVER}
                            accessFile={false}
                            name={t("KYC_UPLOAD_FRONT_LBL")}
                            // onChange={(value) => {
                            //   onFileUploadDocs(value, "vatUpload");
                            // }}
                            onChange={(newFiles) =>
                              handleEditOCRConformFileChange(
                                newFiles,
                                "nationalIdFront",
                                OCRFieldNames.NATIONAL_ID,
                                DocTypes.NATIONAL_ID_FRONT
                              )
                            }
                            onDelete={() =>
                              handleEditingDeleteFile(
                                "nationalIdFront",
                                OCRFieldNames.NATIONAL_ID
                              )
                            }
                          />
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={12}>
                      {formType !== "editForm" && (
                        <Form.Item
                          name="nationalIdBack"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("NATIONAL_ID_BACK_UPLOAD_REQUIRED"),
                            },
                          ]}
                        >
                          <Fileupload
                            filetype={DocTypes.NATIONAL_ID_BACK}
                            defaultThumbFile={
                              formValues?.nationalIdBack
                                ? formValues?.nationalIdBack?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.nationalIdBack
                                ? formValues?.nationalIdBack?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.nationalIdBack
                                ? formValues?.nationalIdBack?.FileName
                                : frontDocs?.FileName
                            }
                            entityId=""
                            entityType={EntityTypes.DRIVER}
                            accessFile={false}
                            name={t("KYC_UPLOAD_BACK_LBL")}
                            onChange={(value) => {
                              onFileUploadDocs(value, "nationalIdBack");
                            }}
                            updateFormValue={(val) => {
                              addDriverForm.setFieldsValue({
                                nationalIdBack: val,
                              });
                            }}
                          />
                        </Form.Item>
                      )}
                      {formType === "editForm" && (
                        <Form.Item
                          name="nationalIdBack"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("NATIONAL_ID_BACK_UPLOAD_REQUIRED"),
                            },
                          ]}
                          valuePropName="value"
                          getValueFromEvent={(e) => {
                            // if your component emits [ { file, fileThumbUrl } ]
                            if (Array.isArray(e) && e.length > 0) {
                              return {
                                // File: e[0].file,
                                // FileThumbURL: e[0].fileThumbUrl,
                              };
                            }
                            return e;
                          }}
                        >
                          <OCRFilePreviewUploader
                            filetype={DocTypes.NATIONAL_ID_BACK}
                            defaultThumbFile={
                              formValues?.nationalIdBack
                                ? formValues?.nationalIdBack?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.nationalIdBack
                                ? formValues?.nationalIdBack?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.nationalIdBack
                                ? formValues?.nationalIdBack?.FileName
                                : frontDocs?.FileName
                            }
                            entityId=""
                            entityType={EntityTypes.DRIVER}
                            accessFile={false}
                            name={t("KYC_UPLOAD_BACK_LBL")}
                            // onChange={(value) => {
                            //   onFileUploadDocs(value, "vatUpload");
                            // }}
                            onChange={(newFiles) =>
                              handleEditOCRConformFileChange(
                                newFiles,
                                "nationalIdBack",
                                OCRFieldNames.NATIONAL_ID,
                                DocTypes.DL_BACK
                              )
                            }
                            onDelete={() =>
                              handleEditingDeleteFile(
                                "nationalIdBack",
                                OCRFieldNames.NATIONAL_ID
                              )
                            }
                          />
                        </Form.Item>
                      )}
                    </Col>
                  </Row>
                  <Form.Item
                    name="nationalId"
                    rules={[
                      {
                        required: true,
                        message: t("NATIONAL_ID_REQUIRED"),
                      },
                      { validator: validateNotEmpty("national Id") },
                    ]}
                    className="floating-label-form-item"
                  >
                    <Input
                      value={formValues?.nationalId}
                      style={{ width: "100%" }}
                      className="floating-input"
                      placeholder={t("NATIONAL_ID_PLACEHOLDER")}
                      maxLength={20}
                      onChange={(e) =>
                        handleFormChange("nationalId", e.target.value)
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_DRIVER_NATIONAL_ID")} <span>*</span>
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="nationalIdExpiry"
                    rules={[
                      {
                        required: true,
                        message: t("EXPIRY_DATE_REQUIRED"),
                      },
                    ]}
                    className="floating-label-form-item"
                  >
                    <DatePicker
                      className="floating-input"
                      format={format}
                      placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                      disabledDate={disablePastDates}
                      value={
                        formValues?.nationalIdExpiry
                          ? dayjs(formValues.nationalIdExpiry, format)
                          : null
                      }
                      onChange={(date, dateString) =>
                        handleFormChange("nationalIdExpiry", dateString)
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_DRIVER_EXPIRY_DATE")} <span>*</span>
                    </label>
                  </Form.Item>
                  {formValues?.serviceType?.length > 0 &&
                  formValues?.serviceType.includes("Domestic") &&
                  formValues?.serviceType?.length === 1 ? (
                    <></>
                  ) : (
                    <>
                      <span className="star-color">
                        {t("FLEET_DRIVER_PASSPORT")} <span>*</span>
                      </span>
                      <Row gutter={16}>
                        <Col span={12}>
                          {formType !== "editForm" && (
                            <Form.Item
                              name="passportFront"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("PASSPORT_FRONT_UPLOAD_REQUIRED"),
                                },
                              ]}
                            >
                              <Fileupload
                                filetype={DocTypes.PASSPORT_FRONT}
                                defaultThumbFile={
                                  formValues?.passportFront
                                    ? formValues?.passportFront?.FileThumbURL
                                    : frontDocs?.FileThumbURL
                                }
                                defaultFile={
                                  formValues?.passportFront
                                    ? formValues?.passportFront?.FileURL
                                    : frontDocs?.FileURL
                                }
                                fileName={
                                  formValues?.passportFront
                                    ? formValues?.passportFront?.FileName
                                    : frontDocs?.FileName
                                }
                                entityId=""
                                entityType={EntityTypes.DRIVER}
                                accessFile={false}
                                name={""}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "passportFront");
                                }}
                                updateFormValue={(val) => {
                                  addDriverForm.setFieldsValue({
                                    passportFront: val,
                                  });
                                }}
                              />
                            </Form.Item>
                          )}
                          {formType === "editForm" && (
                            <Form.Item
                              name="passportFront"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("PASSPORT_FRONT_UPLOAD_REQUIRED"),
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              <OCRFilePreviewUploader
                                filetype={DocTypes.PASSPORT_FRONT}
                                defaultThumbFile={
                                  formValues?.passportFront
                                    ? formValues?.passportFront?.FileThumbURL
                                    : frontDocs?.FileThumbURL
                                }
                                defaultFile={
                                  formValues?.passportFront
                                    ? formValues?.passportFront?.FileURL
                                    : frontDocs?.FileURL
                                }
                                fileName={
                                  formValues?.passportFront
                                    ? formValues?.passportFront?.FileName
                                    : frontDocs?.FileName
                                }
                                entityId=""
                                entityType={EntityTypes.DRIVER}
                                accessFile={false}
                                name={""}
                                // onChange={(value) => {
                                //   onFileUploadDocs(value, "vatUpload");
                                // }}
                                onChange={(newFiles) =>
                                  handleEditOCRConformFileChange(
                                    newFiles,
                                    "passportFront",
                                    OCRFieldNames.PASSPORT,
                                    DocTypes.PASSPORT_FRONT
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "passportFront",
                                    OCRFieldNames.PASSPORT
                                  )
                                }
                              />
                            </Form.Item>
                          )}
                        </Col>
                        <Col span={12}>
                          {formType !== "editForm" && (
                            <Form.Item
                              name="passportBack"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("PASSPORT_BACK_UPLOAD_REQUIRED"),
                                },
                              ]}
                            >
                              <Fileupload
                                filetype={DocTypes.PASSPORT_BACK}
                                defaultThumbFile={
                                  formValues?.passportBack
                                    ? formValues?.passportBack?.FileThumbURL
                                    : frontDocs?.FileThumbURL
                                }
                                defaultFile={
                                  formValues?.passportBack
                                    ? formValues?.passportBack?.FileURL
                                    : frontDocs?.FileURL
                                }
                                fileName={
                                  formValues?.passportBack
                                    ? formValues?.passportBack?.FileName
                                    : frontDocs?.FileName
                                }
                                entityId=""
                                entityType={EntityTypes.DRIVER}
                                accessFile={false}
                                name={t("KYC_UPLOAD_BACK_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "passportBack");
                                }}
                                updateFormValue={(val) => {
                                  addDriverForm.setFieldsValue({
                                    passportBack: val,
                                  });
                                }}
                              />
                            </Form.Item>
                          )}
                          {formType === "editForm" && (
                            <Form.Item
                              name="passportBack"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("PASSPORT_BACK_UPLOAD_REQUIRED"),
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              <OCRFilePreviewUploader
                                filetype={DocTypes.PASSPORT_BACK}
                                defaultThumbFile={
                                  formValues?.passportBack
                                    ? formValues?.passportBack?.FileThumbURL
                                    : frontDocs?.FileThumbURL
                                }
                                defaultFile={
                                  formValues?.passportBack
                                    ? formValues?.passportBack?.FileURL
                                    : frontDocs?.FileURL
                                }
                                fileName={
                                  formValues?.passportBack
                                    ? formValues?.passportBack?.FileName
                                    : frontDocs?.FileName
                                }
                                entityId=""
                                entityType={EntityTypes.DRIVER}
                                accessFile={false}
                                name={t("KYC_UPLOAD_BACK_LBL")}
                                // onChange={(value) => {
                                //   onFileUploadDocs(value, "vatUpload");
                                // }}
                                onChange={(newFiles) =>
                                  handleEditOCRConformFileChange(
                                    newFiles,
                                    "passportBack",
                                    OCRFieldNames.PASSPORT,
                                    DocTypes.PASSPORT_BACK
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "passportBack",
                                    OCRFieldNames.PASSPORT
                                  )
                                }
                              />
                            </Form.Item>
                          )}
                        </Col>
                      </Row>
                      <Form.Item
                        name="passportNumber"
                        rules={[
                          {
                            required: true,
                            message: t("PASSPORT_NO_REQUIRED"),
                          },
                          { validator: validateNotEmpty("passport number") },
                        ]}
                        className="floating-label-form-item"
                      >
                        <Input
                          value={formValues?.passportNumber}
                          style={{ width: "100%" }}
                          className="floating-input"
                          placeholder={t("PASSPORT_NO_PLACEHOLDER")}
                          maxLength={20}
                          onChange={(e) =>
                            handleFormChange("passportNumber", e.target.value)
                          }
                        />
                        <label className="floating-label">
                          {t("FLEET_DRIVER_PASSPORT_NO")}
                          <span>*</span>
                        </label>
                      </Form.Item>
                      <Form.Item
                        name="passportExpiry"
                        rules={[
                          {
                            required: true,
                            message: t("EXPIRY_DATE_REQUIRED"),
                          },
                        ]}
                        className="floating-label-form-item"
                      >
                        <DatePicker
                          className="floating-input"
                          format={format}
                          placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                          disabledDate={disablePastDates}
                          value={
                            formValues?.passportExpiry
                              ? dayjs(formValues.passportExpiry, format)
                              : null
                          }
                          onChange={(date, dateString) =>
                            handleFormChange("passportExpiry", dateString)
                          }
                        />
                        <label className="floating-label">
                          {t("FLEET_DRIVER_EXPIRY_DATE")} <span>*</span>
                        </label>
                      </Form.Item>
                      {/* VISA */}
                      <span className="star-color">
                        {t("FLEET_DRIVER_VISA")} <span></span>
                      </span>
                      {visa?.map((data, index) => (
                        <div key={index}>
                          {visa?.length > 1 && index !== 0 && (
                            <Row
                              justify={"end"}
                              className="delete-visa"
                              onClick={() => {
                                const updatedVisa = [...visa];
                                updatedVisa.splice(index, 1);
                                setVisa(updatedVisa);
                              }}
                            >
                              {t("REMOVE_KEY")}
                            </Row>
                          )}

                          {/* ***** BEFORE : Edit OCR Only Fileupload Component Used ******  */}
                          {/* <Form.Item
                              className="floating-label-form-item"
                              // name={["visa", index, "frontDoc"]}
                              rules={[
                                {
                                  validator: (_, value) => {
                                    console.log("validator value", value);
                                    if (
                                      value &&
                                      (value.fileName || value.FileName)
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(t("VISA_DOC_UPLOAD_REQUIRED"))
                                    );
                                  },
                                },
                              ]}
                              // rules={[
                              //   {
                              //     required: true,
                              //     message: t("VISA_DOC_UPLOAD_REQUIRED"),
                              //   },
                              // ]}
                            >
                              <Fileupload
                                filetype={DocTypes.VISA_FRONT}
                                defaultThumbFile={
                                  data.frontDoc?.documentPathThumb
                                }
                                defaultFile={data.frontDoc?.documentPath}
                                fileName={data.frontDoc?.fileName}
                                entityId={""}
                                entityType={EntityTypes.DRIVER}
                                accessFile={true}
                                onChange={(value) => {
                                  handleVisaDocumentChange(value, index, 0);
                                }}
                              />
                            </Form.Item> */}

                          {/* ******* AFTER : Edit OCR implemented for Visa document OCRFilePreviewUploader used  */}
                          {formType === "editForm" ? (
                            data.frontDoc?.documentPathThumb ||
                            data?.issuingCountry ||
                            data?.documentNumber ? (
                              //Case 1: editForm + has documentPathThumb → OCRFilePreviewUploader
                              <Form.Item
                                className="floating-label-form-item"
                                rules={[
                                  {
                                    validator: (_, value) => {
                                      console.log("validator value", value);
                                      if (
                                        value &&
                                        (value.fileName || value.FileName)
                                      ) {
                                        return Promise.resolve();
                                      }
                                      return Promise.reject(
                                        new Error(t("VISA_DOC_UPLOAD_REQUIRED"))
                                      );
                                    },
                                  },
                                ]}
                                valuePropName="value"
                                getValueFromEvent={(e) => {
                                  // if your component emits [ { file, fileThumbUrl } ]
                                  if (Array.isArray(e) && e.length > 0) {
                                    return {
                                      // File: e[0].file,
                                      // FileThumbURL: e[0].fileThumbUrl,
                                    };
                                  }
                                  return e;
                                }}
                              >
                                <OCRFilePreviewUploader
                                  filetype={DocTypes.VISA_FRONT}
                                  defaultThumbFile={
                                    data.frontDoc?.documentPathThumb
                                  }
                                  defaultFile={data.frontDoc?.documentPath}
                                  fileName={data.frontDoc?.fileName}
                                  entityId={""}
                                  entityType={EntityTypes.DRIVER}
                                  accessFile={false}
                                  name={t("KYC_UPLOAD_BACK_LBL")}
                                  onChange={(newFiles) =>
                                    handleEditOCRConformFileChange(
                                      newFiles,
                                      "visa",
                                      OCRFieldNames.VISA,
                                      DocTypes.VISA_FRONT,
                                      index
                                    )
                                  }
                                  onDelete={() =>
                                    handleVisaDeleteFileUpload(index)
                                  }
                                />
                              </Form.Item>
                            ) : (
                              //Case 2: editForm + NO documentPathThumb → Fileupload
                              <Form.Item
                                className="floating-label-form-item"
                                rules={[
                                  {
                                    validator: (_, value) => {
                                      console.log("validator value", value);
                                      if (
                                        value &&
                                        (value.fileName || value.FileName)
                                      ) {
                                        return Promise.resolve();
                                      }
                                      return Promise.reject(
                                        new Error(t("VISA_DOC_UPLOAD_REQUIRED"))
                                      );
                                    },
                                  },
                                ]}
                              >
                                <Fileupload
                                  filetype={DocTypes.VISA_FRONT}
                                  defaultThumbFile={
                                    data.frontDoc?.documentPathThumb
                                  }
                                  defaultFile={data.frontDoc?.documentPath}
                                  fileName={data.frontDoc?.fileName}
                                  entityId={""}
                                  entityType={EntityTypes.DRIVER}
                                  accessFile={true}
                                  onChange={(value) =>
                                    handleVisaDocumentChange(value, index, 0)
                                  }
                                />
                              </Form.Item>
                            )
                          ) : (
                            //Case 3: NOT editForm → Fileupload
                            <Form.Item
                              className="floating-label-form-item"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    console.log("validator value", value);
                                    if (
                                      value &&
                                      (value.fileName || value.FileName)
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(t("VISA_DOC_UPLOAD_REQUIRED"))
                                    );
                                  },
                                },
                              ]}
                            >
                              <Fileupload
                                filetype={DocTypes.VISA_FRONT}
                                defaultThumbFile={
                                  data.frontDoc?.documentPathThumb
                                }
                                defaultFile={data.frontDoc?.documentPath}
                                fileName={data.frontDoc?.fileName}
                                entityId={""}
                                entityType={EntityTypes.DRIVER}
                                accessFile={true}
                                onChange={(value) =>
                                  handleVisaDocumentChange(value, index, 0)
                                }
                              />
                            </Form.Item>
                          )}

                          {/* {data?.document?.map((visaDocument, documentIndex) => {
                          return (
                            <>
                              
                              {data?.document?.length - 1 == documentIndex && (
                                <div style={{display:"flex",justifyContent:"right"}}>
                                <Button
                                  type="secondary"
                                  icon={<PlusOutlined />}
                                  className="add-doc"
                                  onClick={() => addVisaDocument(index)}
                                  disabled={visa?.length>=5}
                                >
                                  
                                 {t("ADD_VISA_KEY")} Document
                                </Button>
                                </div>
                              )} 
                            </>
                          );
                        })} */}

                          <Form.Item
                            className="floating-label-form-item"
                            //   name={"visa_" + index + "_issuingCountry"}
                            name={["visa", index, "issuingCountry"]}
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: t("ISSUE_COUNTRY_VALIDATION"),
                            //   },
                            // ]}
                          >
                            <Select
                              name="issuingCountry"
                              className="floating-selectt"
                              options={countryOptions}
                              showSearch
                              placeholder={t("ISSUING_COUNTRY_PLACEHOLDER")}
                              value={data?.issuingCountry}
                              fieldNames={{ label: "name", value: "name" }}
                              onChange={(value) => {
                                //   addDriverForm.setFieldsValue({
                                //     ["visa_" + index + "_issuingCountry"]: value,
                                //   });
                                //   handleFormChange("visa_" + index + "_issuingCountry", value);
                                handleVisa({ issuingCountry: value }, index);
                              }}
                              loading={issuingCountriesListWaiter}
                              filterOption={(input, option) =>
                                option.name
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            />
                            <label className="floating-label">
                              {t("ISSUING_COUNTRY_KEY")}
                              <span></span>
                            </label>
                          </Form.Item>
                          <Form.Item
                            name={["visa", index, "documentNumber"]}
                            className="floating-label-form-item"
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: t("VISA_NO_REQUIRED"),
                            //   },
                            // ]}
                          >
                            <Input
                              value={data?.documentNumber || ""}
                              style={{ width: "100%" }}
                              className="floating-input"
                              placeholder={t("VISA_PLACEHOLDER")}
                              maxLength={20}
                              onChange={(e) => {
                                //   handleFormChange(
                                //     // "visa_" + index + "_documentNumber",
                                //     // e.target.value
                                //   );
                                handleVisa(
                                  { documentNumber: e.target.value },
                                  index
                                );
                              }}
                            />
                            <label className="floating-label">
                              {t("FLEET_DRIVER_VISA_NO")} <span></span>
                            </label>
                          </Form.Item>
                          <Form.Item
                            className="floating-label-form-item"
                            name={["visa", index, "expiryDate"]}
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: t("EXPIRY_DATE_REQUIRED"),
                            //   },
                            // ]}
                          >
                            <DatePicker
                              className="floating-input"
                              format={format}
                              placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                              disabledDate={disablePastDates}
                              value={
                                data?.expiryDate
                                  ? dayjs(
                                      data.expiryDate,
                                      "YYYY-MM-DD"
                                    ).isValid()
                                    ? dayjs(data.expiryDate, "YYYY-MM-DD")
                                    : dayjs(data.expiryDate, "DD/MM/YYYY")
                                  : null
                              }
                              onChange={(date, dateString) => {
                                //   handleFormChange("visa_" + index + "_expiryDate", dateString);
                                handleVisa({ expiryDate: dateString }, index);
                              }}
                            />
                            <label className="floating-label">
                              {t("FLEET_DRIVER_EXPIRY_DATE")} <span></span>
                            </label>
                          </Form.Item>
                        </div>
                      ))}
                      <Button
                        type="secondary"
                        icon={<PlusOutlined />}
                        className="add-doc"
                        onClick={addVisa}
                      >
                        {/* {t("KYC_INFO_ADD_VISA")} */}
                        {t("ADD_VISA_KEY")}
                      </Button>
                    </>
                  )}
                </div>
              ) : isOcrFileUpload ? (
                // ************** OCRUPload Screen *****************
                <>
                  <div className="ocr-file-upload-block">
                    {ocrConfirmedFiles.length === 0 ? (
                      <AutofillDocUpload
                        onFileUpload={handleFileChange}
                        filetype={frontDocs}
                        multipleUploadedFilesData={uploadedFileData}
                        onFileDelete={handleFileDelete}
                        onViewSample={handleViewSampleClick}
                        ownerType={ownerType}
                      />
                    ) : (
                      <DocumentListView
                        documentData={ocrConfirmedFiles}
                        onDelete={handleOCRConfirmFileDelete}
                        openUploadDrawer={() => setOpenDrawer(true)}
                        ocrParsedDataDocuments={ocrParsedData?.documents || []}
                      />
                    )}
                  </div>
                </>
              ) : nextBtn ? (
                // ************** ADD NEW DRIVER BASIC INFO *****************
                <div className="truck-form-items">
                  <Row className="truck-form-items-mobile">
                    <Col span={5} style={{ paddingRight: "8px" }}>
                      <Form.Item
                        name="countryCode"
                        className="floating-label-form-item"
                      >
                        <Select
                          type="number"
                          showSearch
                          className="floating-selectt country-code-select"
                          popupClassName="country-code-popup"
                          placeholder={t("COUNTRY_CODE_LBL")}
                          fieldNames={{
                            label: "label",
                            value: "phone_code",
                          }}
                          disabled={verifyMobile}
                          loading={mobileCountryCodeLoader}
                          value={addDriverForm.getFieldValue("countryCode")}
                          options={mobileCountryCodeList.map((item) => ({
                            ...item,
                            key: `${item.phone_code}-${
                              item.country_code
                            }-${item.name.replace(/\s+/g, "")}`, // Unique key
                          }))}
                          onChange={(e) => handleFormChange("countryCode", e)}
                          onSearch={(value) => {
                            if (!/^\d*$/.test(value)) {
                              return;
                            }
                          }}
                          filterOption={(input, option) =>
                            option?.searchKey?.includes(input.toLowerCase())
                          }
                        />
                        <label className="floating-label">
                          {t("COUNTRY_CODE_LBL")} <span>*</span>
                        </label>
                      </Form.Item>
                    </Col>
                    <Col span={19}>
                      <Form.Item
                        name="mobileNumber"
                        className="floating-label-form-item"
                        rules={[
                          {
                            required: true,
                            message: t("MOBILE_NO_REQUIRED"),
                          },
                          {
                            pattern: /^[0-9]*$/,
                            message: t("MOBILE_NO_VALIDATION_REQUIRED"),
                          },
                          {
                            validator: (rule, value) =>
                              validateMobileNumber(
                                addDriverForm?.getFieldValue("countryCode"),
                                value,
                                t
                              ),
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "100%" }}
                          name="mobileNumber"
                          className="floating-input"
                          disabled={verifyMobile}
                          placeholder={t("MOBILE_NO_PLACEHOLDER")}
                          onChange={(e) =>
                            handleFormChange("mobile", e.target.value)
                          }
                          value={addDriverForm?.getFieldValue("mobileNumber")}
                          minLength={minMaxMobileNoLength.minLength}
                          maxLength={minMaxMobileNoLength.maxLength}
                        />
                        <label className="floating-label">
                          {t("FLEET_DRIVER_MOBILE_NO")} <span>*</span>
                        </label>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    name="driverName"
                    rules={[
                      { required: true, message: t("DRIVER_NAME_REQUIRED") },
                      {
                        pattern: /^[A-Za-z ]+$/,
                        message: t("DRIVER_NAME_VALIDATION_MSG"),
                      },
                      { validator: validateNotEmpty("driver name") },
                    ]}
                    className="floating-label-form-item"
                  >
                    <Input
                      maxLength={50}
                      style={{ width: "100%" }}
                      value={formValues?.driverName}
                      className="floating-input"
                      placeholder={t("DRIVER_NAME_PLACEHOLDER")}
                      onChange={(e) =>
                        handleFormChange("driverName", e.target.value)
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCKS_DRIVER_NAME")} <span>*</span>
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="serviceType"
                    className="floating-label-form-item"
                    rules={[
                      { required: true, message: t("SERVICE_TYPE_REQUIRED") },
                    ]}
                  >
                    <Select
                      className="floating-selectt"
                      placeholder="Select"
                      options={serviceTypesList}
                      value={formValues?.serviceType}
                      mode="multiple"
                      fieldNames={{
                        label: "serviceTypeDesc",
                        value: "serviceTypeName",
                      }}
                      name="serviceType"
                      onChange={(value) =>
                        handleFormChange("serviceType", value)
                      }
                    />
                    <label className="floating-label">
                      {t("SIGNUP_BASIC_INFO_SERVICE_TYPE")} <span>*</span>
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="country"
                    className="floating-label-form-item"
                  >
                    <Select
                      className="floating-selectt"
                      options={countryOptions}
                      showSearch
                      placeholder={t("SIGNUP_BASIC_INFO_ADDRESS_PH")}
                      value={addDriverForm?.getFieldValue("country")}
                      disabled={verifyMobile}
                      fieldNames={{ label: "name", value: "name" }}
                      onChange={handleCountryChange}
                      loading={countriesListWaiter}
                      filterOption={(input, option) =>
                        option.name
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    />
                    <label className="floating-label">
                      {t("SIGNUP_BASIC_INFO_COUNTRY")} <span>*</span>
                    </label>
                  </Form.Item>
                  <Form.Item name="city" className="floating-label-form-item">
                    <Select
                      className="floating-selectt"
                      placeholder={t("SIGNUP_BASIC_INFO_ADDRESS_PH")}
                      showSearch
                      options={cityOptions}
                      value={formValues?.city}
                      fieldNames={{
                        label: "name",
                        value: "name",
                      }}
                      loading={cityOptionsWaiter}
                      onChange={
                        (val) => handleFormChange("city", val)
                        // addDriverForm.setFieldsValue({ city: val })
                      }
                      filterOption={(input, option) =>
                        option.name
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    />
                    <label className="floating-label">
                      {t("SIGNUP_BASIC_INFO_CITY")}
                      {/* <span>*</span> */}
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="address"
                    className="floating-label-form-item"
                  >
                    <Placepicker
                      className="floating-selectt"
                      name="address"
                      showSearch
                      defaultAdd={addressDetail.address}
                      onChange={handleLocationChange}
                      defaultLocation={{
                        lat: addressDetail.latitude,
                        lng: addressDetail.longitude,
                      }}
                      value={formValues?.address}
                    />
                    <label className="floating-label">
                      {t("SIGNUP_BASIC_INFO_ADDRESS")}
                      {/* <span>*</span> */}
                    </label>
                  </Form.Item>
                </div>
              ) : (
                // ADD NEW DRIVER STEP-1
                <div>
                  <Row className="truck-form-items-mobile">
                    <Col span={5} style={{ paddingRight: "8px" }}>
                      <Form.Item
                        rules={[
                          {
                            required: true,
                            message: t("COUNTRY_CODE_REQUIRED"),
                          },
                        ]}
                        name="countryCode"
                        className="floating-label-form-item"
                      >
                        <Select
                          showSearch
                          className="floating-selectt country-code-select"
                          popupClassName="country-code-popup"
                          placeholder={t("COUNTRY_CODE_LBL")}
                          fieldNames={{
                            label: "label",
                            value: "phone_code",
                          }}
                          loading={mobileCountryCodeLoader}
                          value={addDriverForm?.getFieldValue("countryCode")}
                          options={mobileCountryCodeList.map((item) => ({
                            ...item,
                            key: `${item.phone_code}-${
                              item.country_code
                            }-${item.name.replace(/\s+/g, "")}`, // Unique key
                          }))}
                          onChange={(value, option) => {
                            console.log("onChange option", option.country_code);
                            setCountryCodeName(option.country_code);
                            handleFormChange("countryCode", value);
                          }}
                          filterOption={(input, option) =>
                            option?.searchKey?.includes(input.toLowerCase())
                          }
                        />
                        <label className="floating-label">
                          {t("COUNTRY_CODE_LBL")} <span>*</span>
                        </label>
                      </Form.Item>
                    </Col>
                    <Col span={19}>
                      <Form.Item
                        name="mobileNumber"
                        className="floating-label-form-item"
                        rules={[
                          {
                            required: true,
                            message: t("MOBILE_NO_REQUIRED"),
                          },
                          {
                            pattern: /^[0-9]*$/,
                            message: t("MOBILE_NO_VALIDATION_REQUIRED"),
                          },
                          {
                            validator: (rule, value) =>
                              validateMobileNumber(
                                formValues?.countryCode,
                                value,
                                t
                              ),
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "100%" }}
                          className="floating-input"
                          name="mobileNumber"
                          placeholder={t("MOBILE_NO_PLACEHOLDER")}
                          onChange={(e) =>
                            handleFormChange("mobileNumber", e.target.value)
                          }
                          minLength={minMaxMobileNoLength.minLength}
                          maxLength={minMaxMobileNoLength.maxLength}
                        />
                        <label className="floating-label">
                          {t("FLEET_DRIVER_MOBILE_NO")} <span>*</span>
                        </label>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}
              {/* *********************  Normal flow Buttons ********************** */}
              {!isOcrFileUpload && (
                <Form.Item className="btn-line">
                  <Button
                    type="secondary"
                    className="cancel-btn"
                    onClick={() => {
                      if (formType === "editForm") {
                        onClose();
                      }
                      if (nextBtn) {
                        setNextBtn(false);
                      }
                      // else if(nextBtnTwo){
                      //     setNextBtnTwo(false);
                      //     setNextBtn(true)
                      // }
                      else {
                        onClose();
                      }
                    }}
                  >
                    {formType === "editForm"
                      ? t("COMMON_CANCEL_BTN")
                      : nextBtn
                      ? t("COMMON_BACK_BTN")
                      : t("COMMON_CANCEL_BTN")}
                  </Button>
                  <Button
                    type="secondary"
                    loading={btnLoader}
                    className="submit-btn"
                    onClick={onSubmitHandler}
                  >
                    {formType === "editForm"
                      ? t("COMMON_SAVE_BTN")
                      : nextBtnTwo
                      ? t("ADD_DRIVER_KEY")
                      : t("NEXT_KEY")}
                  </Button>
                </Form.Item>
              )}
              {/* ******************** Skip Porceed and Submit button for OCRUpload ************************** */}
              {isOcrFileUpload && (
                <Row
                  justify="center"
                  gutter={8}
                  style={{
                    width: "100%",
                    bottom: 0,
                    position: "sticky",
                    zIndex: 2,
                  }}
                >
                  <Col span={12}>
                    <Button
                      style={{ width: "100%", margin: "0px" }}
                      size="large"
                      className="skip-button"
                      onClick={() => {
                        onSkipSectionChange();
                      }}
                    >
                      Skip
                    </Button>
                  </Col>
                  {ocrConfirmedFiles.length === 0 ? (
                    <Col span={12}>
                      <Button
                        style={{ width: "100%", margin: "0px" }}
                        size="large"
                        className="enter-button"
                        onClick={onClickProceed}
                      >
                        Proceed
                      </Button>
                    </Col>
                  ) : (
                    <Col span={12}>
                      <Button
                        style={{ width: "100%", margin: "0px" }}
                        size="large"
                        className="enter-button"
                        onClick={onClickSubmit}
                      >
                        Submit
                      </Button>
                    </Col>
                  )}
                </Row>
              )}
            </Form>
          ) : (
            <div className="exist-content">
              {addFleet ? (
                <div className="addfleet-detail">
                  <Row gutter={16}>
                    <Col span={12}>
                      <Card
                        title={
                          <div className="card-title">
                            {t("FLEET_DRIVER_BASIC_INFORMATION")}
                          </div>
                        }
                      >
                        <div className="img-div">
                          <img src={DriverGruardImg} alt="Truck" />
                        </div>
                        <div className="details-rows">
                          <Row gutter={[8, 8]} className="data-row">
                            <Col span={8}>
                              <span>{t("FLEET_DRIVER_NAME")}</span>
                              <span>
                                {driverData?.name ? driverData?.name : "NA"}
                              </span>
                            </Col>
                            <Col span={8}>
                              <span>{t("FLEET_DRIVER_MOBILE_NO")}</span>
                              <span>
                                {driverData?.mobileNumber
                                  ? driverData?.mobileNumber
                                  : "NA"}
                              </span>
                            </Col>
                            <Col span={8}>
                              <span>{t("FLEET_DRIVER_STATUS")}</span>
                              <span>
                                {driverData?.lbrStatus
                                  ? driverData?.lbrStatus
                                  : "NA"}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    </Col>

                    <Col span={12}>
                      <Card
                        title={
                          <div className="card-title">
                            {t("FLEET_TRUCKS_UPLOADED_DOC")}
                          </div>
                        }
                      >
                        <div className="doc-data">
                          {driverDocs?.length > 0 &&
                            driverDocs?.map((item) => (
                              <div>
                                <Row gutter={16} className="data-row">
                                  <Col span={9}>
                                    <span className="trucks-span">
                                      {item.type}
                                    </span>
                                  </Col>
                                  <Col span={15} className="doc-file">
                                    <Row justify={"end"}>
                                      <img
                                        src={
                                          item?.frontDoc?.documentPath
                                            ? item?.frontDoc?.documentPath
                                            : ""
                                        }
                                        alt="alt"
                                      />
                                      {item.type !== "Visa" && (
                                        <img
                                          src={
                                            item?.backDoc?.documentPath
                                              ? item?.backDoc?.documentPath
                                              : ""
                                          }
                                          alt="alt"
                                        />
                                      )}
                                    </Row>
                                  </Col>
                                </Row>
                                <Row gutter={16} className="data-row">
                                  <Col span={10}>
                                    <span>
                                      {item.type} {t("NUMBER_KEY")}
                                    </span>
                                    <span>
                                      {item?.documentNumber
                                        ? item?.documentNumber
                                        : "NA"}
                                    </span>
                                  </Col>
                                  <Col span={14}>
                                    <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>
                                    <span>
                                      {item?.expiryDate
                                        ? moment(item?.expiryDate).format(
                                            format
                                          )
                                        : "NA"}
                                    </span>
                                  </Col>
                                </Row>
                                <div className="bottom-border"></div>
                              </div>
                            ))}
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </div>
              ) : (
                <div className="exist-content">
                  <img src={ExistsImg} alt="" />
                  <span>{t("DRIVER_EXIST_MSG")}</span>
                </div>
              )}
              <div className="button-row">
                <Button
                  type="secondary"
                  className="cancel-btn"
                  onClick={() => {
                    setAddFleet(false);
                    setDriverExist(false);
                  }}
                >
                  {addFleet ? "Try Another Driver" : "No"}
                </Button>
                <Button
                  type="secondary"
                  loading={btnLoader}
                  className="submit-btn"
                  onClick={addDriverinFleetHandler}
                >
                  {addFleet ? t("ADD_DRIVER_KEY") : t("COMMON_YES_BTN")}
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>

      {/*  *********** Upload Document Drawer  ************ */}
      <Drawer
        className="drawer-upload"
        title={
          <>
            <div className="drawer-title">
              Upload Document
              <Button
                icon={<CloseOutlined />}
                type="text"
                onClick={() => setOpenDrawer(false)}
                style={{ fontSize: "16px" }}
              />
            </div>
          </>
        }
        onClose={() => {
          setOpenDrawer(false);
        }}
        closable={false}
        open={openDrawer}
        styles={{
          header: {
            padding: "0",
            border: "none",
          },
          body: {
            padding: "0",
            position: "relative",
          },
        }}
      >
        <>
          <div className="drawer-upload-body">
            <OCRFileUpload
              // onChange={handleFileChange}
              onChange={handleOCRConformFileChange}
              uploadedFiles={ocrConfirmedFiles}
              // onDelete={handleFileDelete}
              onDelete={handleOCRConfirmFileDelete}
            />
          </div>
          <Row
            justify="center"
            gutter={8}
            style={{
              width: "100%",
              bottom: 0,
              position: "absolute",
            }}
          >
            <Col span={12}>
              <Button
                style={{ width: "100%", margin: "0px" }}
                size="large"
                className="skip-button"
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
            </Col>
            <Col span={12}>
              <Button
                style={{ width: "100%", margin: "0px" }}
                size="large"
                className="submit-button"
                onClick={handleDrawerFileSubmit}
                disabled={false}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </>
      </Drawer>
      {/* ************************ Missing Doc Modal **************** */}
      <Modal
        open={missingDocModal}
        footer={null}
        closable={false}
        width={400}
        onCancel={() => setMissingDocModal(false)}
        centered
        style={{ textAlign: "center", padding: "16px 16px 32px 16px" }}
      >
        <MissingDocModal
          onClose={() => setMissingDocModal(false)}
          handleMissingDocSubmit={() => {
            setMissingDocModal(false);
            setNextBtn(true);
            setIsOcrFileUpload(false);
          }}
          isFileUploaded={!ocrParsedData && ocrConfirmedFiles.length > 0}
        />
      </Modal>

      {/* DISCARD MODAL */}
      <DiscardWarningModal
        visible={isDiscardModalVisible}
        onOk={() => handleProceedDiscardOcrData()}
        onCancel={() => setIsDiscardModalVisible(false)}
      />
    </>
  );
};
export default AddDriver;
